import { distinctUntilChanged, throttleTime } from 'rxjs/operators';
import { Component, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, Renderer2, SimpleChanges, TemplateRef, ViewChild, ViewChildren, effect, input, NgZone } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AttentionsService, PatchAttentionBody } from 'src/app/core/services/attentions.service';
import { CustomValidators } from 'src/app/core/validators/custom-validators';
import { Agreement } from 'src/app/shared/models/agreement';
import { Attention } from 'src/app/shared/models/attention';
import Swal, { SweetAlertIcon, SweetAlertOptions } from 'sweetalert2';
import { Provider } from 'src/app/shared/models/provider';
import { Patient } from 'src/app/shared/models/patient';
import { AttentionStates } from 'src/app/core/enums/attentionsStates';
import { Case } from 'src/app/shared/models/case';
import { ATTENTIONS_BACKGROUND_COLORS, ATTENTIONS_COLORS, AttentionsFacade } from 'src/app/abstraction/attentions.facade';
import { DateService } from 'src/app/core/services/date.service';
import { StateAttention } from 'src/app/shared/models/stateAttention';
import { Subscription, BehaviorSubject, Subject } from 'rxjs';
import { Practice } from 'src/app/shared/models/practice';
import { AttentionToProcess } from 'src/app/shared/models/attentionToProcess';
import { NomenclatorFacade } from '../../../../abstraction/nomenclator.facade';
import { CasesFacade, CaseDateFilters } from '../../../../abstraction/cases.facade';
import { OPTIONS } from '../provision-scheme/provision-scheme.component';
import { CalendarEvent, CalendarEventTimesChangedEvent, CalendarMonthViewDay, CalendarView, DAYS_OF_WEEK } from 'angular-calendar';
import { EvolutionsFacade } from '../../../../abstraction/evolutions.facade';
import { DialogComponent } from 'src/app/shared/components/dialog/dialog.component';
import { AlertService } from '../../../../core/services/alert.service';
import { DateAdapter } from '@angular/material/core';
import { ProvisionFee } from '../../../../shared/models/provisionFee';
import { Provision } from '../../../../shared/models/provision';
import { ProvisionAgreementFilters } from '../../../../shared/models/ProvisionAgreementFilters';
import { ProvisionsFacade } from 'src/app/abstraction/provisions.facade';
import { ProvisionQPS } from 'src/app/core/services/provisions.service';
import { ButtonsNewDateScheduleNavigator } from '../../../../core/services/general.service';

import moment from 'moment';
import * as momentRange from 'moment-range';
import { MatRadioButton } from '@angular/material/radio';
import { MessageDialogComponent } from 'src/app/shared/components/message-dialog/message-dialog.component';
import { SelectionModel } from '@angular/cdk/collections';
import { GeneralService } from 'src/app/core/services/general.service';
import { EntitiesFacade } from 'src/app/abstraction/entities.facade';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { CalendarCaseService } from 'src/app/core/services/calendar-case.service';
import { AttentionOverlap } from 'src/app/shared/models/attentionOverlap';
import { AttentionEdit } from 'src/app/shared/models/submodels/attentionEdit';
import { ProvisionFeeWithPractice } from 'src/app/shared/models/submodels/provisionFeeWithPractice';
import { MyDateAdapter } from 'MyDateAdapter';
import { BreadcrumbService } from 'src/app/shared/services/breadcrumb.service';
import { ViewManagementEntities } from 'src/app/core/enums/ViewManagementEntities';
import { HttpBaseResponseErrorTeaPot } from 'src/app/shared/models/httpBaseResponseErrorTeaPot';
import { CaseModuleComposed } from 'src/app/shared/models/module';
import { AttentionType } from 'src/app/core/enums/attentionType';
import { ModulesService } from 'src/app/core/services/modules.service';

const colors: { primary: string, secondary: string }[] = [
    {
        primary: '#609E50',
        secondary: '#609E50',
    },
    {
        primary: '#FF7A00',
        secondary: '#FF7A00',
    },
    {
        primary: '#2D00F7',
        secondary: '#2D00F7',
    },
    {
        primary: ' #9B5DE5',
        secondary: '#9B5DE5',
    },
    {
        primary: '#D100D1',
        secondary: '#D100D1',
    },
    {
        primary: '#D02700',
        secondary: '#D02700',
    },
    {
        primary: '#1994B1',
        secondary: '#1994B1',
    },
    {
        primary: '#F2AD13',
        secondary: '#F2AD13',
    },
    {
        primary: '#F2545B',
        secondary: '#F2545B',
    },
    {
        primary: '#297045',
        secondary: '#297045',
    },
    {
        primary: '#F78E69',
        secondary: '#F78E69',
    },
    {
        primary: '#41309E',
        secondary: '#41309E',
    },
    {
        primary: '#334151',
        secondary: '#334151',
    },
    {
        primary: '#944394',
        secondary: '#944394',
    },
    {
        primary: '#00BB94',
        secondary: '#00BB94',
    },
    {
        primary: '#8DCB00',
        secondary: '#8DCB00',
    },
    {
        primary: '#8A6552',
        secondary: '#8A6552',
    },
    {
        primary: '#A93F55',
        secondary: '#A93F55',
    },
]

type SlimCase = Pick<Case, 'id' | 'patient'>;

interface FilterAttentions {
    date: Date,
    range: momentRange.DateRange
}

interface PostAttentionsWithForce {
    attentions: { fromDate: Date, toDate: Date, stateId: number, agreementId: number, provisionFeeId?: number }[],
    force: boolean
}

@Component({
    selector: 'app-schedule-case',
    templateUrl: './schedule-case.component.html',
    styleUrls: ['./schedule-case.component.scss'],
    providers: [
        { provide: DateAdapter, useClass: MyDateAdapter }, // It's mandatory, NO delete -> set first day MONDAY
    ],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0', opacity: '0', fontSize: '0px' })),
            state('expanded', style({ height: '*', fontSize: '10px' })),
            transition('expanded <=> collapsed', animate('230ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
            transition('expanded <=> void', animate('230ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ]
})

export class ScheduleCaseComponent implements OnInit {

    optionViewSelected = input<string>();
    @Input('case') case: Case | SlimCase;
    @Input('cases') cases: Array<Case | SlimCase> = [];
    @Input("attentions")
    set attentions(value: Attention[]) {
        this._attentionsInput = value;
    }
    get attentions(): Attention[] {
        return this._attentionsInput;
    }
    @Input('provisionsFromAgreements') provisionsFromAgreements: Provision[] = null
    @Input("selectedOption") selectedOption: OPTIONS; // PROVISION OR SUPPLY
    @Input("viewColumnsBillAndDebit") viewColumnsBillAndDebit: boolean;
    // IMPORTANT: template compares against lower-case values ('calendario' / 'listado')
    @Input() optionSelected: string = 'calendario';
    @Input() billSuppliesExternally: number[];
    @Input() fromProviderSchedule: boolean = false;
    @Input() caseModules: CaseModuleComposed[] = [];
    @Input() caseModuleProvisionFeesWithPractices: ProvisionFeeWithPractice[] = [];
    // Input to controller delete attentions batch button
    @Input("provisionsFilteredCount") provisionsFilteredCount: number;
    @Input("provisionsSuppliesFilteredCount") provisionsSuppliesFilteredCount: number;
    @Input("ordersFilteredCount") ordersFilteredCount: number;
    @Input("provisionAgreements") provisionAgreements?: Agreement[];
    @Input() selectedCaseModuleFromParent: { id: number | null, name: string | null } = { id: null, name: null };
    @Input() ordersRadioSelected: boolean = false;
    //
    @Input() allProvisionsWithoutFilter: Provision[];
    @Output() agreementNewAttention = new EventEmitter<any>(null);
    @Output() refreshDataFiltered = new EventEmitter();
    @Output() openModifySuppliesProvisionFee = new EventEmitter<number[]>();
    @Output() scheduleViewModeChanged = new EventEmitter<string>(); // 'calendario' | 'listado'

    @ViewChild('scheduleDialogTemplate', { static: true }) scheduleDialogTemplate: TemplateRef<any>;
    @ViewChild("extraAttentionsTemplate", { static: true }) extraAttentionsTemplate: TemplateRef<any>;
    @ViewChild('deleteWizardAttentions', { static: true }) deleteWizardAttentions: TemplateRef<any>;
    @ViewChild('editAttentionDialogTemplate', { static: true }) editAttentionDialogTemplate: TemplateRef<any>;
    @ViewChildren('targetElement', { read: ElementRef }) targetElements!: QueryList<ElementRef>;

    // practiceAttentions: Attention[] = [];
    // practiceModuleAttentions: Attention[] = [];
    // moduleAttentions: Attention[] = [];
    // attentionsToModulesFlow: Attention[] = [];

    caseModulesFiltered: CaseModuleComposed[] = [];
    private _attentionsInput: Attention[] = [];
    view: CalendarView = CalendarView.Month;
    attentionsToProcess: AttentionToProcess[] = [];
    processSuccessOnAttentions: boolean = false;
    moduleAttentionSelected: boolean = false;
    billingModuleAttentionSelected: boolean = false;
    sourceElement
    _attentionsCaseActive: Subscription;
    // Atenciones separadas para mostrar solapamiento
    guardiaAttentions: Attention[] = [];
    attentionsWithOverlap: AttentionOverlap[] = [];
    attentionToEdit: AttentionEdit;
    focusEmitter: string;
    defaultValueRepeatAttention: number = 1;
    ATTENTION_STATES = AttentionStates;
    defaultValueStateAttention: number = this.ATTENTION_STATES.REALIZADA;
    canExecute$ = new BehaviorSubject<string>('_');
    _canExecute: Subscription;
    provisionFeesWithoutCostOrFee: ProvisionFee[] = [];
    provisionFeesWithKairos: ProvisionFee[] = [];
    ATTENTIONS_COLORS = ATTENTIONS_COLORS;
    rangeToNavigate: CaseDateFilters;
    filterAttentions: FilterAttentions;
    viewSelectedCalendarCase: CalendarView;
    editMode: string;
    provisionsExpanded = new SelectionModel<number>(true, []);
    scheduleForm: FormGroup;
    AttentionType = AttentionType;

    // Debug: loguea errores de scheduleForm en consola mientras editás.
    // Setear en false para silenciar.
    private readonly debugScheduleForm: boolean = true;
    private _scheduleFormDebugSub?: Subscription;
    private _scheduleFormLastSignature: string = '';
    private _scheduleFormLastStatus?: string;
    isRepeatSchedule = false;
    swalWithCustomizeButtons: any;

    _dialogRefSupply: MatDialogRef<any>;
    _dialogRefAttByDay: MatDialogRef<any>;
    _dialogRefPopUpAddAttentions: MatDialogRef<any>;
    _dialogRefWizardDelete: MatDialogRef<any>;
    _dialogRefEditAttention: MatDialogRef<any>;
    dayChipsSelected: Map<string, boolean> = new Map<string, boolean>();
    // Agreement que se muestra en el dialog
    activeAttention: Attention;
    agreementAttentionDefault: number;
    datesToPostSelected: moment.Moment[] = [];
    elementsProvidersDialog: Provider[] = [];
    allPatientsDialog: Patient[] = [];
    allAgreementsDialog: Agreement[] = [];
    allAgreementsDialogList: Agreement[] = [];
    agreements: Agreement[];
    allModulesAttentions: Attention[];
    moduleAttentionsUnified: Attention[] = [];
    _allModulesAttentions: Subscription;
    private selectedCaseModuleId$ = new BehaviorSubject<number | null>(null);
    private requestedModuleAttentionsForRange = false;
    caseModuleProvisionSelected: Provision = null;
    caseModuleAgreementId: number = null;
    provisionSelected: Provision = null;
    agreementSelected: Agreement;
    editingCaseModuleAttention: boolean = false;
    loadingCreateAttention = false;
    objectValues = Object.values;
    loadingCalendar: boolean = true;
    loadingInnerCalendar: boolean = false;
    // attentions: Attention[];
    supplyList: Attention[];
    _attentions: Subscription;
    moduleAttentions: Attention[] = [];
    practiceModuleAttentions: Attention[] = [];
    practiceAttentions: Attention[] = [];
    supplyAttentions: Attention[] = [];
    supplyModuleAttentions: Attention[] = [];
    orderAttentions: Attention[] = [];
    orderModuleAttentions: Attention[] = [];
    _filteredAttentions: Attention[] = [];
    get filteredAttentions(): Attention[] {
        return this._filteredAttentions;
    }
    set filteredAttentions(value: Attention[]) {
        value = this.sortAttentions(value);
        let attentionsFilteredByDateRange = this.filterAttentionsByDateRange(value);
        const practice: Attention[] = [];
        const order: Attention[] = [];
        const supply: Attention[] = [];
        const practiceModule: Attention[] = [];
        const orderModule: Attention[] = [];
        const supplyModule: Attention[] = [];
        const module: Attention[] = [];

        for (let i = 0; i < attentionsFilteredByDateRange.length; i++) {
            const att = attentionsFilteredByDateRange[i];

            if (att.type === AttentionType.PRACTICE) {
                if (!att.isSupply) practice.push(att);
                else (att.notManageable ? supply : order).push(att);
                continue;
            }

            if (att.type === AttentionType.PRACTICE_MODULE) {
                if (!att.isSupply) practiceModule.push(att);
                else (att.notManageable ? supplyModule : orderModule).push(att);
                continue;
            }

            if (att.type === AttentionType.MODULE) {
                module.push(att);
                continue;
            }
        }

        this.practiceAttentions = practice;
        this.orderAttentions = order;
        this.supplyAttentions = supply;
        this.practiceModuleAttentions = practiceModule;
        this.orderModuleAttentions = orderModule;
        this.supplyModuleAttentions = supplyModule;
        this.moduleAttentions = module;
        this._filteredAttentions = this.updateAttentions();
    }

    filterAttentionsByDateRange(attentions: Attention[]): Attention[] {
        let attentionsFiltered = attentions.filter(att => {
            return moment(att.fromDate).isBetween(moment(this.dateRange?.historyFromDate), moment(this.dateRange?.historyToDate), 'day', '[]');
        });
        return attentionsFiltered;
    }

    updateAttentions(): Attention[] {
        switch (true) {
            case this.selectedOption === OPTIONS.PROVISION:
                return [...this.practiceAttentions]
                break;
            case this.selectedOption === OPTIONS.SUPPLY:
                return [...this.supplyAttentions]
                break;
            case this.selectedOption === OPTIONS.ORDER:
                return [...this.orderAttentions]
                break;
            case this.selectedOption === OPTIONS.MODULE:
                return [...this.practiceModuleAttentions, ...this.supplyModuleAttentions, ...this.moduleAttentions, ...this.orderModuleAttentions]
                break;
            default: return []
                break;
        }
    }

    attentionsToShow: Attention[];
    totalsByAttentionsState = new Array(Object.values(AttentionStates).length / 2).fill(0); // Create array with state totals with zero
    initialAgreementId: number = undefined;
    loadingEditAttention = false;
    agreementsFromPatient: Agreement[];
    stateAttentionSelected: number[];
    allProvisionsCase: Provision[];
    durationAttention;
    createAttentionFromOutside: boolean = false;
    radiobuttonsDisabled: boolean = false;
    public enumStates = AttentionStates;
    statesSelected = new SelectionModel<number>(true, []);
    agreementsExpanded = new SelectionModel<number>(true, [])
    errorContent: HttpBaseResponseErrorTeaPot;
    // Repeat attention - only Visitas
    repeatTimesAttention: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    repeatAttention: number = 1;

    selectionToUpdateValue: string;
    showRadiobuttons: boolean = false;
    ATTENTIONS_BACKGROUND_COLORS = ATTENTIONS_BACKGROUND_COLORS;
    colorsForAgreements: Map<number, { primary: string, secondary: string }> = new Map<number, { primary: string, secondary: string }>();
    events: CalendarEvent<any>[] = [];
    monthEvents: CalendarEvent<any>[] = [];
    modulesMonthEvents: CalendarEvent<any>[] = [];
    modulesBillingEvents: CalendarEvent<any>[] = [];
    viewDate: Date = new Date();
    previousViewDate = this.viewDate;
    viewDateX: Date = new Date();
    buttonsNewDateScheduleNavigator: ButtonsNewDateScheduleNavigator
    extraDayAttentions: any;
    dayOpened: moment.Moment;
    displayColumnsForAttentions: string[] = [];
    displayColumnsForAttentionsSupplies: string[] = [];

    // For spinner
    isLoadingGetAttentions: boolean; _isLoadingGetAttentions: Subscription;
    isLoadingGettingEvolutions: boolean; _isLoadingGettingEvolutions: Subscription;
    isLoadingFilteredAttentions: boolean;

    provisionFees: ProvisionFeeWithPractice[];
    provisionFeesSupplies: ProvisionFee[];
    _allProvisionsCase: Subscription;
    provisionFeeSelected: ProvisionFeeWithPractice;
    caseModuleSelected: CaseModuleComposed;
    caseModuleProvisions: ProvisionFeeWithPractice[];

    minDate: Date; // For mat-calendar filter
    maxDate: Date; // For mat-calendar filter

    // HISTORY MODE
    historyModeActivated: boolean;
    _historyModeActivated: Subscription;
    _historyModeDate: Subscription;
    historyModeDate: Date;
    rangePeriodSelector: momentRange.DateRange;
    provisionQPS: ProvisionQPS;
    _filtersOnProvisions: Subscription;
    provisionAgreementsInput: ProvisionAgreementFilters;
    _provisionsDisplayedOnScreen: Subscription;
    provisionsDispayed: Provision[];
    _provisionsForCase: Subscription; provisions: Provision[];
    weekStartsOn = DAYS_OF_WEEK.MONDAY;
    dateRange: CaseDateFilters;
    dateSelectedFromOtherComponent: Date;
    _loadAttentions: Subscription;
    isNextDay: boolean = false;
    refresh: Subject<any> = new Subject();
    isDeleteModeAttentionFromGridAgreements: boolean = false;
    _screenToJump: Subscription
    moment = moment;
    CalendarView = CalendarView

    attentionStates: StateAttention[] = [
        {
            id: AttentionStates.AGENDADA,
            name: 'Agendada',
        },
        {
            id: AttentionStates.EN_CURSO,
            name: 'En curso',
        },
        {
            id: AttentionStates.NO_REALIZADA,
            name: 'No realizada',
        },
        {
            id: AttentionStates.REALIZADA,
            name: 'Realizada',
        },
        {
            id: AttentionStates.FACTURABLE,
            name: 'Facturable',
        },
        {
            id: AttentionStates.DEBITADA,
            name: 'Debitada',
        },
        {
            id: AttentionStates.EN_PROCESO,
            name: 'En proceso',
        },
        {
            id: AttentionStates.INFORMADA,
            name: 'Informada',
        },
        {
            id: AttentionStates.NO_INFORMADA,
            name: 'No informada',
        },
    ];
    attentionStatesPost: StateAttention[] = [
        // {
        //     id: AttentionStates.AGENDADA,
        //     name: 'Agendada',
        // },
        // {
        //     id: AttentionStates.FACTURABLE,
        //     name: 'Facturable',
        // },
        {
            id: AttentionStates.REALIZADA,
            name: 'Realizada',
        },
        {
            id: AttentionStates.NO_REALIZADA,
            name: 'No realizada',
        },
    ];
    permittedStates: AttentionStates[] = [
        this.ATTENTION_STATES.AGENDADA,
        this.ATTENTION_STATES.REALIZADA,
        this.ATTENTION_STATES.NO_REALIZADA,
        this.ATTENTION_STATES.FACTURABLE,
    ]

    // FORM
    // public readonly PROVIDER = 'provider';
    // public readonly PROVIDER_SEARCHING = 'providerSearching';
    public readonly PRACTICE = 'practice';
    public readonly PRACTICE_SEARCHING = 'practiceSearching';
    public readonly PATIENT = 'patient';
    public readonly AGREEMENT = 'agreement';
    public readonly DATE_FROM = 'fromDate';
    public readonly DATE_TO = 'toDate';
    public readonly DATE_FROM_UPDATE = 'dateFromUpdate';
    public readonly DATE_TO_UPDATE = 'dateToUpdate';
    public readonly TIME_FROM = 'timeFrom';
    public readonly TIME_TO = 'timeTo'
    // public readonly TIME_DURATION = 'timeDuration';
    public readonly HOUR_DURATION = 'hourDuration';
    public readonly MINUTE_DURATION = 'minuteDuration';
    public readonly DATE_END_REPEAT = 'dateEndRepeat';
    public readonly STATE_ATTENTION = 'stateAttention';
    public readonly REPEAT_ATTENTION = 'repeatAttention';
    public readonly PROVISION_FEE = 'provisionFee';
    public readonly QUANTITY = 'quantity';


    // Getter para determinar si estamos en flujo de módulos
    get isModulesFlow(): boolean {
        return this.selectedOption === OPTIONS.MODULE;
    }

    // Siempre devolvé una lista de {id, patient}
    get casesSlim(): SlimCase[] {
        if (this.cases?.length) return this.cases.map(c => ({ id: c.id, patient: c.patient }));
        return this.case ? [{ id: this.case.id, patient: this.case.patient }] : [];
    }

    // Útiles
    get caseIdSet(): Set<number> { return new Set(this.casesSlim.map(c => c.id)); }
    get patientByCaseId(): Map<number, Patient> {
        return new Map(this.casesSlim.map(c => [c.id, c.patient]));
    }

    get patientForm() {
        return this.scheduleForm.get(this.PATIENT).value;
    }
    get agreementForm() {
        return this.scheduleForm.get(this.AGREEMENT).value;
    }
    get provisionFeeForm() {
        return this.scheduleForm.get(this.PROVISION_FEE).value;
    }
    get dateFromForm() {
        return this.scheduleForm.get(this.DATE_FROM).value;
    }
    get dateToForm() {
        return this.scheduleForm.get(this.DATE_TO).value;
    }
    get timeFromForm() {
        return this.scheduleForm.get(this.TIME_FROM).value;
    }
    get timeToForm() {
        return this.scheduleForm.get(this.TIME_TO).value;
    }
    get hourDurationForm() {
        return this.scheduleForm.get(this.HOUR_DURATION).value;
    }
    get minuteDurationForm() {
        return this.scheduleForm.get(this.MINUTE_DURATION).value;
    }
    get dateEndRepeatForm() {
        return this.scheduleForm.get(this.DATE_END_REPEAT).value;
    }
    get stateAttentionForm() {
        return this.scheduleForm.get(this.STATE_ATTENTION).value;
    }
    get repeatAttentionForm() {
        return this.scheduleForm.get(this.REPEAT_ATTENTION).value;
    }
    // set providerForm(providerId: number) {
    //     providerId != null ? this.scheduleForm?.controls[this.PROVIDER].setValue(providerId.toString())
    //         : this.scheduleForm?.controls[this.PROVIDER].reset();
    // }
    set patientForm(patientId: number) {
        patientId != null ? this.scheduleForm?.controls[this.PATIENT].setValue(patientId.toString())
            : this.scheduleForm?.controls[this.PATIENT].reset();
    }
    set agreementForm(agreementId: number) {
        agreementId != null ? this.scheduleForm?.controls[this.AGREEMENT].setValue(agreementId.toString())
            : this.scheduleForm?.controls[this.AGREEMENT].reset();
    }
    set dateFromForm(date: Date) {
        date != null ? this.scheduleForm?.controls[this.DATE_FROM].setValue(date)
            : this.scheduleForm?.controls[this.DATE_FROM].reset();
    }
    set dateToForm(date: Date) {
        date != null ? this.scheduleForm?.controls[this.DATE_TO].setValue(date)
            : this.scheduleForm?.controls[this.DATE_TO].reset();
    }
    set timeFromForm(hourAndMinute: string) {
        hourAndMinute != null ? this.scheduleForm?.controls[this.TIME_FROM].setValue(hourAndMinute)
            : this.scheduleForm?.controls[this.TIME_FROM].reset();
    }
    set timeToForm(hourAndMinute: string) {
        hourAndMinute != null ? this.scheduleForm?.controls[this.TIME_TO].setValue(hourAndMinute)
            : this.scheduleForm?.controls[this.TIME_TO].reset();
    }
    set hourDurationForm(hours: number) {
        hours != null ? this.scheduleForm?.controls[this.HOUR_DURATION].setValue(hours)
            : this.scheduleForm?.controls[this.HOUR_DURATION].reset();
    }
    set minuteDurationForm(minutes: number) {
        minutes != null ? this.scheduleForm?.controls[this.MINUTE_DURATION].setValue(minutes)
            : this.scheduleForm?.controls[this.MINUTE_DURATION].reset();
    }
    set dateEndRepeatForm(date: Date) {
        date != null ? this.scheduleForm?.controls[this.DATE_END_REPEAT].setValue(date)
            : this.scheduleForm?.controls[this.DATE_END_REPEAT].reset();
    }
    set stateAttentionForm(stateId: number) {
        stateId != null ? this.scheduleForm?.controls[this.STATE_ATTENTION].setValue(stateId.toString())
            : this.scheduleForm?.controls[this.STATE_ATTENTION].reset();
    }
    set repeatAttentionForm(repeatTimes: number) {
        repeatTimes != null ? this.scheduleForm?.controls[this.REPEAT_ATTENTION].setValue(repeatTimes)
            : this.scheduleForm?.controls[this.REPEAT_ATTENTION].reset();
    }


    constructor(
        public attentionsService: AttentionsService,
        private dialog: MatDialog,
        private formBuilder: FormBuilder,
        private attentionsFacade: AttentionsFacade,
        private dateService: DateService,
        private nomenclatorFacade: NomenclatorFacade,
        private casesFacade: CasesFacade,
        private evolutionsFacade: EvolutionsFacade,
        private alertService: AlertService,
        private provisionsFacade: ProvisionsFacade,
        private ren: Renderer2,
        private generalService: GeneralService,
        public entitiesFacade: EntitiesFacade,
        public calendarCaseService: CalendarCaseService,
        private breadcrumbService: BreadcrumbService,
        private ngZone: NgZone,
        private modulesService: ModulesService
    ) {
        effect(() => {
            if (!!this.optionViewSelected()) {
                this.optionSelected = this.optionViewSelected()
            }

        })

    }

    ngOnInit(): void {
        this.proccesToBillOrDebit(); // Subscribe to traffic-lights (semáforo) for execute

        this.swalWithCustomizeButtons = Swal.mixin({
            customClass: {
                confirmButton: 'btnSwalConfirm',
                cancelButton: 'btnSwalCancel'
            },
            buttonsStyling: true
        })

        this._provisionsForCase = this.provisionsFacade.getAllProvisionsCase$().subscribe(prov => {
            if (!!prov) {
                this.provisions = prov;
                this.agreementsFromPatient = this.provisions.flatMap(provision => provision.agreements).filter(agreement => !!agreement);
                this.loadAttentionsByCase();
            } else {
                ``
                // this.provisionsFacade.loadAllProvisionsForCase(this.case.id);
            }
        })

        // Spinner control
        this._isLoadingGetAttentions = this.attentionsFacade.isLoadingGetAttentions$().subscribe(loadingAttentions => this.isLoadingGetAttentions = loadingAttentions);
        this._isLoadingGettingEvolutions = this.evolutionsFacade.isLoadingGetEvolutions$().subscribe(loadingEvolutions => this.isLoadingGettingEvolutions = loadingEvolutions);

        this._historyModeDate = this.casesFacade.getCaseDateFilters$().subscribe(rangeDate => {
            if (!!rangeDate) {
                this.dateRange = { ...rangeDate, historyToDate: moment(moment(rangeDate.historyToDate).format('YYYY-MM-DD')).toDate() }; // Selector
                this.rangeToNavigate = this.attentionsService.getPeriodToLoadAttentions(this.dateRange.historyFromDate, this.dateRange.historyToDate); // Attentions

                // Filter caseModules that might have arrived before dateRange
                this.filterCaseModulesByDateRange();

                // this.viewDate = this.dateRange.historyFromDate;
                // this.updateScheduleView();
            }
        })

        // For shows sub-provisions filtered or displayeds on screen inside combo when create attention
        this._filtersOnProvisions = this.provisionsFacade.getFiltersOnProvisions$()
            .pipe(
                // Use a lightweight, targeted comparator instead of JSON.stringify which allocates and is expensive.
                distinctUntilChanged((a, b) => this.filtersEqual(a, b)),
                throttleTime(100, undefined, { leading: true, trailing: true })
            )
            .subscribe(filters => {

                this.provisionAgreementsInput = filters;

                if (this.provisionAgreementsInput?.provisionFees?.length > 0) {

                    let auxProvisions: Provision[] = [];

                    if (this.provisionAgreementsInput && this.provisionAgreementsInput.provisions) { // .provisions can be undefined
                        for (let provision of this.provisionAgreementsInput.provisions) {
                            let provisionFeesfiltered = this.provisionAgreementsInput.provisionFees.filter(pFee => pFee.provisionId == provision.id)
                            provision = { ...provision, provisionFees: [...provisionFeesfiltered] }
                            auxProvisions.push(provision);
                        }
                        this.provisionAgreementsInput.provisions = [...auxProvisions]
                    }
                }

                // En flujo módulos, reconstruir el calendario/lista con los nuevos filtros
                if (this.isModulesFlow) {
                    this.rebuildModuleCalendarAndList();
                    return;
                }

                // Defer heavy recomposition so the checkbox toggle can update immediately in the UI.
                // Use requestAnimationFrame + runOutsideAngular to let the browser paint and keep heavy CPU work off Angular's change detection.
                this.ngZone.runOutsideAngular(() => {
                    requestAnimationFrame(() => {
                        try {
                            // Do CPU-heavy transforms outside Angular to avoid triggering CD repeatedly
                            this.provisionsAndCompose(this.provisionsDispayed);

                            // Re-filter attentions when orders change (needed after removing setAttentionsCaseActive from onFilterAttentions)
                            this.loadAttentionsByCase();

                            // Also refresh events / month mapping after recomposition
                            const newEvents = this.attentionsToEvents(this.filteredAttentions);
                            // Map month events computation can be heavy; compute outside and then patch in
                            this.mapMonthEvents();

                            // Re-enter Angular to assign state that requires change detection
                            this.ngZone.run(() => {
                                this.events = newEvents;
                            });
                        } finally {
                            // Intentionally left blank: removed instrumentation (performance.now) used for debugging.
                        }
                    });
                });
            })

        // For shows sub-provisions filtered or displayeds on screen inside combo when create attention
        // If doesn't exist filters then provisions
        this._provisionsDisplayedOnScreen = this.provisionsFacade.getProvisionsDisplayedOnScreen$().subscribe(provisions => {
            if (provisions === null && this.provisionsFromAgreements !== null) {
                // Fixed 'if' to 'if'
                this.provisionsDispayed = this.provisionsFromAgreements?.filter(aprov => !aprov.isSupply);
            } else {
                this.provisionsDispayed = provisions?.filter(aprov => !aprov.isSupply); // Always is calculated
            }
            if (!!provisions) {
                // Always is filtered with provisions displayed on screen
                this.provisionsAndCompose(this.provisionsDispayed);
            }
        });

        // // Subscribe to ModuleAttentions (always). We only render module UI when isModulesFlow=true and a module is selected.
        // this._allModulesAttentions = this.modulesFacade
        //     .getModulesAttentions$()
        //     .subscribe(attentions => {
        //         this.allModulesAttentions = Array.isArray(attentions) ? attentions : [];
        //         this.maybeRebuildModuleView();
        //     });

        // // Drive module view from (selected module id) and (module attentions) so order doesn't matter.
        // combineLatest([
        //     this.selectedCaseModuleId$.pipe(distinctUntilChanged()),
        //     this.modulesFacade.getModulesAttentions$(),
        // ])
        //     .pipe(
        //         filter(() => this.isModulesFlow),
        //     )
        //     .subscribe(([moduleId, attentions]) => {
        //         this.allModulesAttentions = Array.isArray(attentions) ? attentions : [];
        //         if (moduleId != null) {
        //             this.maybeRebuildModuleView();
        //         }
        //     });

        if (this.isModulesFlow) {
            this.ensureModuleAttentionsLoaded();
        }

    }

    ngAfterViewInit() {
        this._screenToJump = this.breadcrumbService.getScreenToJump$().subscribe(event => {
            if (event == ViewManagementEntities.ATTENTIONS_OLD_AND_OMITTED || event == ViewManagementEntities.ATTENTIONS_WITHOUT_BILLING || event == ViewManagementEntities.SUPPLIES_NOT_BILLING) {
                this.focusEmitter = event;
            }
            this.applyMaxWidth();
        })
    }

    // private isModuleAttention(att: Attention | null | undefined): boolean {
    //     return !!att && att.caseModuleId != null && att.agreementId == null;
    // }

    // private isNonModuleAttention(att: Attention | null | undefined): boolean {
    //     if (!att) return false;
    //     if (this.isModuleAttention(att)) return false;
    //     const pfMap = this.getProvisionFeeCaseModuleIdByProvisionFeeId();
    //     return this.getCaseModuleIdForAttention(att, pfMap) == null;
    // }

    // Al presionar 'Agendar atención facturable de módulo'
    onAddCaseModuleBillingAttention() {
        // Entramos explícitamente en modo "facturable"
        this.moduleAttentionSelected = true;
        this.billingModuleAttentionSelected = true;

        // IMPORTANTÍSIMO: limpiar estado residual del modo acuerdo
        this.caseModuleAgreementId = null;
        this.agreementSelected = null;
        this.provisionFeeSelected = null;

        this.minDate = this.caseModuleSelected?.fromDate;
        this.maxDate = this.caseModuleSelected?.toDate;
        const newDate: Date = moment(this.maxDate).isAfter(moment().add(6, 'months')) ? moment(moment().add(6, 'months')).toDate() : this.maxDate;
        this.dateEndRepeatForm = newDate;

        // Ajustar validadores del form para billing-module
        this.setBillingModuleModeFormValidators();

        // Rango de fechas del módulo
        this.initRepeatRangeForModuleAttention();

        // // Reconstruir calendario filtrado por atenciones tipo MODULE
        this.rebuildMonthEventsFromFilter();
        // this.rebuildModuleCalendarAndList();
    }

    initRepeatRangeForModuleAttention(): void {
        if (!this.isModulesFlow) return;
        if (!this.caseModuleSelected?.vigency) return;

        const parts = this.caseModuleSelected.vigency.split(' - ');
        if (parts.length !== 2) return;

        const start = moment(parts[0], 'DD/MM/YYYY', true);
        const end = moment(parts[1], 'DD/MM/YYYY', true);
        if (!start.isValid() || !end.isValid()) return;

        this.minDate = start.startOf('day').toDate();
        this.maxDate = end.endOf('day').toDate();

        const cappedEnd: Date = moment(this.maxDate).isAfter(moment().add(6, 'months'))
            ? moment().add(6, 'months').toDate()
            : this.maxDate;

        // Use the setter so the reactive form is updated too.
        this.dateEndRepeatForm = cappedEnd;
    }

    applyMaxWidth() {
        const sourceElement = document.querySelector('mwl-calendar-month-cell');
        const sourceWidth = sourceElement?.clientWidth - 10;
        this.targetElements.forEach(targetElement => {
            targetElement.nativeElement.style.width = `${sourceWidth}px`;
            targetElement.nativeElement.style.maxWidth = `${sourceWidth}px`;
        });
    }

    // Filter provisionFees without caseModuleId - classic flow
    provisionsAndCompose(provisions: Provision[]) {
        if (this.fromProviderSchedule) return;
        this.allProvisionsCase = provisions;
        this.provisionFees = provisions.filter(p => !p.isSupply).flatMap(p => (p.provisionFees ?? []).filter(fee => fee.caseModuleId == null).map(fee => ({ ...fee, practice: p.practice })));
        this.assignColorsToAgreements();
    }

    // Filter modules
    // modulesBetweenDates(provisions: Provision[], fromDate: Date, toDate: Date): CaseModuleComposed[] {
    //     const modules: CaseModuleComposed[] = [];
    //     provisions.filter(p => p.isSupply).forEach(provision => {
    //         provision.provisionFees?.forEach(fee => {
    //             if (fee.caseModuleId != null) { // Es módulo
    //                 const vigency = this.getVigencyForCaseModule(provision, fee);
    //                 if (this.dateService.doRangesOverlap(vigency.start, vigency.end, fromDate, toDate)) {}
    //     }

    /**
         *
         * @param attentions attentions selected to bill
         * @returns provisionFee ids
         */
    getProvisionFeeIdsSupplies(attentions: Attention[]): number[] {
        let provFees: number[] = [];
        this.provisionFeesWithoutCostOrFee = [];
        this.provisionFeesWithKairos = [];
        if (this.provisions) {
            this.provisionFeesSupplies = this.provisions.filter(prov => prov.isSupply).flatMap(provision => provision.provisionFees)
            // Get provisionFeeId
            attentions.forEach(att => {
                let auxprovFee = this.provisionFeesSupplies.find(pF => pF.id == att.provisionFeeId && (pF.fixedPrice || pF?.agreement?.providerFee == 0 || pF?.fee == 0)) // ProvisionFee with Kairos or cost 0 or fee 0
                if (auxprovFee) {
                    provFees.push(auxprovFee.id);
                    if (!auxprovFee.fixedPrice && (auxprovFee?.agreement?.providerFee == 0 || auxprovFee?.fee == 0)) {
                        const agreement: Agreement = { provider: att.provider }
                        auxprovFee = { ...auxprovFee, agreement: agreement, practice: att.practice }
                        this.provisionFeesWithoutCostOrFee = [...this.provisionFeesWithoutCostOrFee, auxprovFee]
                    } else {
                        this.provisionFeesWithKairos = [...this.provisionFeesWithKairos, auxprovFee]
                    }
                }
            })
            return provFees;
        }
        return []
    }

    loadAttentionsByCase(loadingCalendar = false, loadingInnerCalendar = false) {
        // En flujo módulos, el calendario/listado del panel principal debe mostrar sólo atenciones de módulos
        // (mismas que el calendario/lista del flujo módulos dentro del dialog).
        if (this.isModulesFlow) {
            this.rebuildModuleCalendarAndList();
            return;
        }
        // load attentions for case
        if (!!this.attentions) {
            this.attentions = this.composeAttentions(this.attentions, this.agreementsFromPatient)
            this.setAttentionsOldAndOmitted();
            this.controlShowsAttentionsIfModeBillOrDebit();
            let attentions = this.attentions;

            if (this.selectedOption == OPTIONS.PROVISION) {
                attentions = attentions.filter(att => !att.isSupply && att.practice?.name != 'Entrega insumos' && att.type === AttentionType.PRACTICE);
            } else if (this.selectedOption == OPTIONS.SUPPLY) {
                attentions = attentions.filter(att => !!att.isSupply);
            } else if (this.selectedOption == OPTIONS.ORDER) {
                attentions = attentions.filter(att => att.isSupply && att.type === AttentionType.PRACTICE && att.notManageable == false);
            } else if (this.selectedOption == OPTIONS.MODULE) {
                attentions = attentions.filter(att => att.type !== AttentionType.PRACTICE);
            }
            // TODO: Necesario para ver el solapamiento de las atenciones
            this.guardiaAttentions = this.attentionsService.filterGuardiaAttentions(this.attentions);
            this.attentionsWithOverlap = this.attentionsService.composeAttentionHasOverlap(this.guardiaAttentions);
            // Apply billing / notManageable filters depending on the current view mode
            if (!this.viewColumnsBillAndDebit) {
                // non-billing mode: hide notManageable supplies
                attentions = attentions?.filter(att => att.notManageable == false);
            } else {
                // billing mode: show different subsets depending on selectedOption
                if (this.selectedOption == OPTIONS.PROVISION) {
                    attentions = attentions?.filter(att => !!att && !!att.practice && att.practice.name != 'Entrega insumos' && !att.notManageable);
                } else if (this.selectedOption == OPTIONS.SUPPLY) {
                    attentions = attentions?.filter(att => !!att && !!att.practice && att.practice.name != 'Entrega insumos' && att.notManageable);
                }
            }
            // No se actualizaba la vista porque se esperaba un cambio en filteredAttentions

            if (this.provisionAgreementsInput != null) {
                /* if(!!this.provisionAgreementsInput.agreements && this.provisionAgreementsInput.agreements.length != 0){
                    this.filteredAttentions = this.provisionAgreementsInput.agreements.flatMap(agr => attentions.filter(att => att.agreementId === agr.id))
                }
                else */
                // Para pestaña ORDER: solo filtrar por orders seleccionados, ignorar otros filtros
                if (this.selectedOption == OPTIONS.ORDER) {
                    if (!!this.provisionAgreementsInput.orders && this.provisionAgreementsInput.orders.length != 0) {
                        this.filteredAttentions = this.provisionAgreementsInput.orders?.flatMap(order => attentions.filter(att => att?.agreementId === order?.agreement?.id && att.type === AttentionType.PRACTICE));
                    } else {
                        // Sin orders seleccionados: mostrar todos los orders
                        this.filteredAttentions = attentions;
                    }
                }
                else if ((!!this.provisionAgreementsInput.provisionFees && this.provisionAgreementsInput.provisionFees.length != 0) || (!!this.provisionAgreementsInput.orders && this.provisionAgreementsInput.orders.length != 0)) {

                    if (this.selectedOption == OPTIONS.PROVISION) {
                        this.filteredAttentions = this.attentionsService.mamushkaCheckBoxes(this.provisionAgreementsInput, attentions)
                    }
                    else if (!!this.provisionAgreementsInput.orders && this.provisionAgreementsInput.orders.length != 0) {
                        this.filteredAttentions = this.provisionAgreementsInput.orders?.flatMap(order => attentions.filter(att => att?.agreementId === order?.agreement?.id && att.type === AttentionType.PRACTICE));

                    } else {
                        this.filteredAttentions = attentions
                    }
                }
                else if (!!this.provisionAgreementsInput.provisionsSupplies && this.provisionAgreementsInput.provisionsSupplies.length != 0) {
                    this.filteredAttentions = this.provisionAgreementsInput.provisionsSupplies.flatMap(sup => attentions.filter(att => att.practiceId === sup.practice.id))
                }
                else {
                    // Sin filtros seleccionados: mostrar todas las attentions ya filtradas por selectedOption
                    this.filteredAttentions = attentions
                }
            } else {
                this.filteredAttentions = attentions
            }
        }
        this.attachPatientToAttentions();

        if (!!this.stateAttentionSelected) {
            this.stateAttentionSelected = [];
        }
        this.getRangeToFilterAttentions();
        this.isLoadingFilteredAttentions = false;
        this.composeAttentionsToAgreements();
        this.assignColorsToAgreements();
        this.events = this.attentionsToEvents(this.filteredAttentions);
        this.mapMonthEvents();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['selectedOption']) {
            if (this.isModulesFlow) {
                this.requestedModuleAttentionsForRange = false;
                this.ensureModuleAttentionsLoaded();
                this.maybeRebuildModuleView();
            } else {
                // Leaving modules flow: clear module-only view state so other flows don't see stale data.
                this.modulesMonthEvents = [];
                this.moduleAttentionSelected = false;
                this.caseModuleSelected = null;
                this.selectedCaseModuleId$.next(null);
            }
        }

        if (changes['optionSelected'] && typeof this.optionSelected === 'string') {
            this.optionSelected = this.optionSelected.toLowerCase();
            if (this.optionSelected === 'listado' && this.selectedOption === OPTIONS.MODULE) {
                this.practiceModuleAttentions = [];
                this.supplyModuleAttentions = [];
                this.orderModuleAttentions = [];
                this.moduleAttentions = [];
            }
        }
        if (!!changes['viewColumnsBillAndDebit'] || !!changes['selectedOption']) {
            this.controlShowsAttentionsIfModeBillOrDebit()
            this.loadAttentionsByCase();
        }

        //Bill supplies attentions automatically after values are loaded
        if (changes['billSuppliesExternally'] && this.billSuppliesExternally?.length > 0) {
            let atte = this.attentionsToProcess.filter(att => att.bill);
            this.onClickFacturableDebitada(atte, true);
        }

        if (changes['allProvisionsWithoutFilter']) {
            this.provisions = changes['allProvisionsWithoutFilter'].currentValue;
            if (!!this.provisions) {
                this.agreementsFromPatient = this.provisions.flatMap(provision => provision.agreements).filter(agreement => !!agreement);
            }
            this.loadAttentionsByCase();
        }

        if (!!changes['attentions'] && !!changes['attentions'].currentValue) {
            this.composeAttentionsToAgreements();
            this.assignColorsToAgreements();
            this.loadAttentionsByCase();
            this.mapMonthEvents();
        }


        if (!!changes['provisionsFromAgreements']) {
            this.provisionsDispayed = this.provisionsFromAgreements?.filter(aprov => !aprov.isSupply);
        }

        // fromProviderSchedule se maneja vía el @Input fromProviderSchedule directamente

        if (!!changes['caseModules'] && changes['caseModules'].currentValue) {
            this.filterCaseModulesByDateRange();
        }
    }

    // Filter caseModules only if dateRange is set
    private filterCaseModulesByDateRange(): void {
        if (!this.dateRange?.historyFromDate || !this.dateRange?.historyToDate || !this.caseModules?.length) return;
        // Combo in the view
        this.caseModulesFiltered = this.modulesService.filterModulesByDateRange(
            { historyFromDate: this.dateRange.historyFromDate, historyToDate: this.dateRange.historyToDate }, this.caseModules
        );
    }

    // cleanAttentionsGroups() {
    //     this.practiceAttentions = [];
    //     this.practiceModuleAttentions = [];
    //     this.moduleAttentions = [];
    //     this.attentionsToModulesFlow = []
    // }

    controlShowsAttentionsIfModeBillOrDebit() {
        // Control which columns to show depending on mode; actual filtering of
        // attentions is performed by `loadAttentionsByCase` to avoid mutating
        // the original `this.attentions` source and losing data when switching views.
        // if (!this.viewColumnsBillAndDebit) {
        //     this.displayColumnsForAttentions = ['fromDate', 'timeRange', 'hours', 'practice', 'state', 'actionsMenu'];
        // } else {
        switch (this.selectedOption) {
            case OPTIONS.PROVISION:
                if (this.viewColumnsBillAndDebit) {
                    this.displayColumnsForAttentions = ['fromDate', 'timeRange', 'hours', 'practice', 'state', 'actionsMenu', 'bill-debit'];
                } else {
                    this.displayColumnsForAttentions = ['fromDate', 'isAuthorized', 'timeRange', 'hours', 'practice', 'provider', 'state', 'actionsMenu'];
                }
                break;

            case OPTIONS.SUPPLY:
            case OPTIONS.ORDER:
                if (this.viewColumnsBillAndDebit) {
                    this.displayColumnsForAttentions = ['fromDate', 'quantity', 'practice', 'state', 'bill-debit'];
                } else {
                    this.displayColumnsForAttentions = ['fromDate', 'timeRange', 'hours', 'practice', 'state'];
                }
                break;

            case OPTIONS.MODULE:
                if (this.viewColumnsBillAndDebit) {
                    this.displayColumnsForAttentions = ['fromDate', 'moduleTimeRange', 'moduleHours', 'practice', 'state', 'actionsMenu', 'bill-debit'];
                    this.displayColumnsForAttentionsSupplies = ['fromDate', 'quantity', 'practice', 'state', 'bill-debit']; // Supply
                } else {
                    this.displayColumnsForAttentions = ['fromDate', 'isAuthorized', 'moduleTimeRange', 'moduleHours', 'practice', 'provider', 'state', 'actionsMenu'];
                    this.displayColumnsForAttentionsSupplies = ['fromDate', 'moduleTimeRange', 'moduleHours', 'practice', 'state']; // Order
                }
                break;

            default:
                break;
        }
        // }
    }

    onClicProcessBillAndDebit(attentions, processBill: boolean = true) {

        if (attentions[0].isSupply) { // All attentions are supply
            const pFIds: number[] = this.getProvisionFeeIdsSupplies(attentions);
            if (pFIds?.length > 0 && this.provisionFeesWithKairos.length > 0) {
                // There are attentions with Kairos, cost 0 or fee 0
                this.attentionsToProcess = [...attentions];
                processBill = false;
                this.openModifySuppliesProvisionFee.emit(pFIds); // Emit to provision-scheme -> execute openModifyProvisionFeeSupplies()
            }
        }
        if (processBill && !!attentions && attentions.length > 0) {
            this.attentionsToProcess = [...attentions];
            this.canExecute$.next(this.attentionsToProcess.filter(att => att.bill === true).length > 0 ? 'bill' : 'debit') // Start-up before subscription
            this.processSuccessOnAttentions = false; // For refresh TOTALS on app-attentions-list-case
        }
    }

    proccesToBillOrDebit() {

        this._canExecute = this.canExecute$.subscribe(control => {

            if (control === 'bill') {
                const atte = this.attentionsToProcess.filter(att => att.bill === true) // TO BILL
                if (atte.length > 0) {
                    this.onClickFacturableDebitada(atte, true);
                }
            }
            if (control === 'debit') {
                const atte = this.attentionsToProcess.filter(att => att.debit === true) // TO DEBIT
                if (atte.length > 0) {
                    this.onClickFacturableDebitada(atte, false);
                } else {
                    this.canExecute$.next('') // Only bill, not debit
                }
            }
            if (control === '') {
                this.processSuccessOnAttentions = true;
            }
        })
    }

    deleteAttentions(attentions: Attention[]): Promise<Attention> {
        return new Promise((resolve, reject) => {
            this.attentionsService.deleteAttentions(attentions).subscribe({
                next: (attention) => resolve(attention),
                error: (error) => reject(error),
            });
        });
    }

    onClickCreateAttention(date?: Date) {
        if (this.fromProviderSchedule) {
            return;
        }

        // Reset all filters, TODO: change if it's necesary keeps the filters
        const filtersReset: ProvisionAgreementFilters = { provisions: [], agreements: [], provisionFees: [], provisionsSupplies: [], provisionAgreementsSupplies: [], orders: [] }
        this.provisionsFacade.setFiltersOnProvisions(filtersReset);

        this.activeAttention = null;
        this.provisionFeeSelected = null;
        this.agreementSelected = null;
        this.isRepeatSchedule = false;
        this.provisionsAndCompose(this.provisionsDispayed);
        this.scheduleForm = this.createScheduleForm();
        this.startScheduleFormDebugLogger();

        // Set to calendar
        this.view = !!this.viewSelectedCalendarCase ? this.viewSelectedCalendarCase : CalendarView.Month;

        // this.viewDate = this.dateRange.historyFromDate; // Set always before opendialog
        // this.getRangeToFilterAttentions();

        this.openDialogCalendar('Agendar', DialogComponent, { maxHeight: '95vh', minWidth: '95%' }, (agreement: Agreement) => {
            this.onCleanAttentions();
            this.scheduleForm.reset();
            this.isRepeatSchedule = false;
        });
        setTimeout(() => {
            if (date) {
                this.dateSelectedFromOtherComponent = date;
            }
        }, 2000);


        // if (date) {
        //     this.provisionFees = this.provisionFees.filter(provFee => {
        //         const rangeProvision = new momentRange.DateRange(moment(provFee.fromDate, 'YYYY-MM-DD').hours(0).minutes(0), !!provFee.toDate ? moment(provFee.toDate, 'YYYY-MM-DD').hours(23).minutes(59) : null);
        //         if (this.createAttentionFromOutside) {

        //             let isBetween = rangeProvision.contains(moment(date, "DD-MM-YYYY"));
        //             let isSameMonthFrom = moment(provFee.fromDate).isSame(moment(date), 'month')
        //             let isSameMonthTo = moment(provFee.toDate).isSame(moment(date), 'month')
        //             return isBetween || isSameMonthFrom || isSameMonthTo
        //         }
        //         return rangeProvision.contains(moment(date))
        //     })
        //     this.createAttentionFromOutside = false;
        // }
    }

    private startScheduleFormDebugLogger(): void {
        if (!this.debugScheduleForm || !this.scheduleForm) return;

        this._scheduleFormDebugSub?.unsubscribe();
        this._scheduleFormDebugSub = new Subscription();

        const emit = (reason: string) => {
            if (!this.scheduleForm) return;

            const snapshot = this.buildScheduleFormErrorSnapshot(this.scheduleForm);
            const signature = JSON.stringify(snapshot);
            const status = this.scheduleForm.status;

            // Log solo si cambia el status o el set de errores (evita spam en cada keypress)
            if (signature === this._scheduleFormLastSignature && status === this._scheduleFormLastStatus) return;

            this._scheduleFormLastSignature = signature;
            this._scheduleFormLastStatus = status;

            if (status === 'VALID') {
                console.log('[scheduleForm] VALID', { reason });
                return;
            }

            console.groupCollapsed(`[scheduleForm] ${status} (${reason})`);
            console.log('formErrors:', snapshot.formErrors);
            if (snapshot.invalidControls.length) {
                console.table(snapshot.invalidControls);
            } else {
                console.log('invalidControls: []');
            }
            console.groupEnd();
        };

        emit('init');

        this._scheduleFormDebugSub.add(this.scheduleForm.statusChanges.subscribe(() => emit('statusChanges')));
        this._scheduleFormDebugSub.add(this.scheduleForm.valueChanges.subscribe(() => emit('valueChanges')));
    }

    private buildScheduleFormErrorSnapshot(form: FormGroup): {
        formErrors: any;
        invalidControls: Array<{ control: string; errors: any; value: any; status: string }>;
    } {
        const invalidControls: Array<{ control: string; errors: any; value: any; status: string }> = [];

        const visit = (group: FormGroup, pathPrefix: string) => {
            Object.keys(group.controls).forEach((key) => {
                const control = group.controls[key];
                const path = pathPrefix ? `${pathPrefix}.${key}` : key;

                if (control instanceof FormGroup) {
                    visit(control, path);
                    return;
                }

                if (control && control.invalid) {
                    invalidControls.push({
                        control: path,
                        errors: control.errors,
                        value: control.value,
                        status: control.status,
                    });
                }
            });
        };

        visit(form, '');
        invalidControls.sort((a, b) => a.control.localeCompare(b.control));

        return {
            formErrors: form.errors,
            invalidControls,
        };
    }

    onEventClickedHandler(event) {
        let attention: Attention = event.calendarEvent;
        let isModuleAttention = attention.type === AttentionType.MODULE;
        let cmName = (attention as any)?.caseModuleName;
        this.editMode = event.editMode;
        let title = 'Atención';
        // event clicked handler
        if (this.fromProviderSchedule) {
            this.attentionToEdit = {
                ...attention,
                practiceDescription: '',
                agreements: [],
                provisionFeeSelected: null
            };
            this._dialogRefEditAttention = this.dialog.open(DialogComponent, {
                data: { template: this.editAttentionDialogTemplate, title, templateClass: 'margin: 0' },
            });

        }
        else {
            switch (true) {
                case attention.isSupply:
                    this.alertService.openInfo('Las atenciones de entrega de insumos se gestionan desde los pedidos');
                    break;

                case !attention.isSupply:
                    let provisionFee: ProvisionFeeWithPractice;
                    if (!isModuleAttention) {
                        provisionFee = this.provisionFees.find(p => p.id == attention.provisionFeeId);

                        if (!provisionFee) {
                            // PRACTICE_MODULE: el provisionFee vive en caseModules, no en provisionsDispayed.
                            // Buscar en la jerarquía caseModules → provisions → provisionFees y construir
                            // provisionFee con practice + agreements directamente, sin pasar por mapCaseAgreements.
                            outerLoop: for (const cm of (this.caseModules ?? [])) {
                                for (const prov of (cm.provisions ?? [])) {
                                    const found = (prov.provisionFees ?? []).find(pf => pf.id === attention.provisionFeeId);
                                    if (found) {
                                        provisionFee = { ...found, practice: prov.practice } as ProvisionFeeWithPractice;
                                        this.agreements = (prov.agreements ?? []).filter(ag => ag.active);
                                        this.composeAttentionsToAgreements();
                                        this.events = this.attentionsToEvents(this.filteredAttentions);
                                        break outerLoop;
                                    }
                                }
                            }
                        } else {
                            this.mapCaseAgreements(provisionFee); // flujo normal de prestaciones
                        }

                        this.attentionToEdit = { ...attention, practiceDescription: this.calculateProvisionFeeName(provisionFee), agreements: this.agreements, provisionFeeSelected: provisionFee };
                    } else {
                        this.attentionToEdit = { ...attention, practiceDescription: cmName, agreements: [], provisionFeeSelected: null };
                    }

                    let title: string = '';
                    switch (this.editMode) {
                        case 'UPD':
                            title = isModuleAttention ? `Editar atención - ${cmName}` : `Editar atención - ${attention.practice?.name}`;
                            break;
                        case 'RPA':
                            title = isModuleAttention ? `Reemplazar acuerdo prestacional - ${cmName}` : `Reemplazar acuerdo prestacional - ${attention.practice?.name}`;
                            break;
                        case 'DSP':
                            title = isModuleAttention ? `${cmName}` : `${attention.practice?.name}`;
                            break;
                        default:
                            title = 'Error';
                            break;
                    }

                    // minWidth: '20%',
                    // maxHeight: '90vh',
                    this._dialogRefEditAttention = this.dialog.open(DialogComponent, {
                        data: { template: this.editAttentionDialogTemplate, title, templateClass: 'margin: 0' },
                    });
                    break;
                default:
                    break;
            }
        }
    }

    createScheduleForm(): FormGroup {
        return this.formBuilder.group({
            [this.PATIENT]: [''],
            [this.PROVISION_FEE]: ['', [CustomValidators.required('Selección requerida')]],
            [this.AGREEMENT]: ['', [CustomValidators.required('Acuerdo prestacional requerido')]],
            [this.DATE_FROM]: [(!!this.activeAttention ? this.activeAttention.fromDate : ''),],
            [this.DATE_TO]: ['',],
            [this.QUANTITY]: [this.calculateAttentionDuration()],
            [this.DATE_FROM_UPDATE]: [(!!this.agreementSelected ? this.agreementSelected.fromDate : ''),],
            [this.DATE_TO_UPDATE]: [(!!this.agreementSelected ? this.agreementSelected.toDate : ''),],
            [this.TIME_FROM]: ['',],
            [this.TIME_TO]: ['',],
            [this.HOUR_DURATION]: ['',],
            [this.MINUTE_DURATION]: ['',],
            [this.DATE_END_REPEAT]: [''],
            [this.STATE_ATTENTION]: ['', [CustomValidators.required('Estado requerido')]],

            // FIX: nunca dejarlo vacío; si no hay nada, default = 1
            [this.REPEAT_ATTENTION]: [String(this.repeatAttention ?? 1)],

            radioButton: new FormControl({ value: '', disabled: false },),
        }, {
            validators: [
                CustomValidators.CVFromToDate(
                    'La fecha de finalización de la repetición debe ser mayor o igual a la fecha de finalización de la atención',
                    'errCVEnd',
                    this.DATE_TO, this.DATE_END_REPEAT
                ),
                CustomValidators.CVFromToDate(
                    'La fecha de finalización de la repetición debe ser mayor o igual a la fecha de inicio de la atención',
                    'errCVEnd',
                    this.DATE_FROM, this.DATE_END_REPEAT
                )
            ]
        });
    }

    calculateAttentionDuration() {
        let fromDate = this.activeAttention?.fromDate ? this.activeAttention.fromDate : null;
        let toDate = this.activeAttention?.toDate ? this.activeAttention.toDate : null;

        return !!toDate ? moment(toDate).diff(moment(fromDate), 'hours') : null;
    }

    validateCheckTypeToUpdateDate() {
        if (this.radiobuttonsDisabled) {
            return false
        }
        return (this.selectionToUpdateValue == 'date') ? true : false;
    }

    validateCheckTypeToUpdateForward() {
        if (this.radiobuttonsDisabled) {
            return false
        }
        return (this.selectionToUpdateValue == 'forward') ? true : false;
    }

    clickRadiobutton(event) {
        switch (event.value) {
            case 'forward':
                if (this.selectionToUpdateValue == 'forward') {
                    this.selectionToUpdateValue = '';
                } else {
                    this.selectionToUpdateValue = event.value;
                }
                break;

            case 'date':
                if (this.selectionToUpdateValue == 'date') {
                    this.selectionToUpdateValue = '';
                } else {
                    this.selectionToUpdateValue = event.value;
                }
                break;
        }
    }

    checkState(element?: MatRadioButton) {
        setTimeout(() => {
            if (!!this.selectionToUpdateValue && this.selectionToUpdateValue === element?.value) {
                element.checked = false;
                this.ren.removeClass(element['_elementRef'].nativeElement, 'cdk-focused');
                this.ren.removeClass(element['_elementRef'].nativeElement, 'cdk-program-focused');
                this.selectionToUpdateValue = null;
            } else {
                this.selectionToUpdateValue = element.value;
            }
        })
    }

    mapCaseAgreements(provisonFeeSelected?: ProvisionFeeWithPractice) {
        //al seleeccionar la provision en flujo norrmal || al seleccionar el caseModule y presionar agendar en un casemodule.provision.agreement
        //entregarle provision feewithpractice
        if (!this.fromProviderSchedule) {
            const pf = provisonFeeSelected ?? this.provisionFeeSelected;
            this.rangePeriodSelector = this.getSchedulePeriodRange();

            this.agreements = this.allProvisionsCase
                .flatMap(provision => {
                    if (
                        provision.active && !provision.isDeliveryPractice
                        && !!provision.practice && !!provision.agreements
                        && !this.nomenclatorFacade.isSupplyPractice(provision.practice.id)
                    ) {
                        provision.agreements.forEach(agreement => {
                            agreement.practice = provision.practice;
                            agreement.provision = provision;
                        });
                        return provision.agreements;
                    }
                })
                .filter((ag: Agreement) => this.isAgreementSchedulableForProvisionFee(ag, pf, pf?.practice));
        }
        this.composeAttentionsToAgreements();
        this.events = this.attentionsToEvents(this.filteredAttentions);
    }

    private getSchedulePeriodRange(): momentRange.DateRange | null {
        if (!this.dateRange?.historyFromDate || !this.dateRange?.historyToDate) {
            return null;
        }

        return new momentRange.DateRange(
            moment(this.dateRange.historyFromDate, 'YYYY-MM-DD').startOf('day'),
            moment(this.dateRange.historyToDate, 'YYYY-MM-DD').endOf('day'),
        );
    }

    private getProvisionFeeRange(provisionFee: ProvisionFee | ProvisionFeeWithPractice): momentRange.DateRange | null {
        if (!provisionFee?.fromDate) {
            return null;
        }

        return new momentRange.DateRange(
            moment(provisionFee.fromDate, 'YYYY-MM-DD').hours(0).minutes(0),
            provisionFee?.toDate ? moment(provisionFee.toDate, 'YYYY-MM-DD').hours(23).minutes(59) : null
        );
    }

    private getAgreementRange(agreement: Agreement): momentRange.DateRange | null {
        if (!agreement?.fromDate) {
            return null;
        }

        return new momentRange.DateRange(
            moment(agreement.fromDate, 'YYYY-MM-DD').hours(0).minutes(0),
            agreement?.toDate ? moment(agreement.toDate, 'YYYY-MM-DD').hours(23).minutes(59) : null
        );
    }

    private getProvisionAgreementIntersectionRange(
        provisionFee: ProvisionFee | ProvisionFeeWithPractice,
        agreement: Agreement
    ): momentRange.DateRange | null {
        const rangeProvision = this.getProvisionFeeRange(provisionFee);
        const rangeAgreement = this.getAgreementRange(agreement);

        if (!rangeProvision || !rangeAgreement) {
            return null;
        }

        return rangeProvision.intersect(rangeAgreement) ?? null;
    }

    private isAgreementSchedulableForProvisionFee(
        agreement: Agreement,
        provisionFee: ProvisionFee | ProvisionFeeWithPractice,
        practice?: Practice
    ): boolean {
        const resolvedPractice = practice ?? (provisionFee as ProvisionFeeWithPractice)?.practice ?? agreement?.practice;
        const rangeAgreement = this.getAgreementRange(agreement);
        const rangePeriodSelector = this.rangePeriodSelector ?? this.getSchedulePeriodRange();

        if (!agreement?.active || !resolvedPractice?.id || !rangeAgreement) {
            return false;
        }

        const agreementPracticeId = agreement?.practice?.id ?? resolvedPractice.id;
        if (Number(agreementPracticeId) !== Number(resolvedPractice.id)) {
            return false;
        }

        const hasValidIntersection = !!this.getProvisionAgreementIntersectionRange(provisionFee, agreement);
        if (!hasValidIntersection) {
            return false;
        }

        if (!rangePeriodSelector) {
            return true;
        }

        return rangePeriodSelector.overlaps(rangeAgreement) || rangePeriodSelector.adjacent(rangeAgreement);
    }

    getCaseModuleAgreementsForProvisionFee(provision: Provision, provisionFee: ProvisionFee): Agreement[] {
        const agreements = Array.isArray(provision?.agreements) ? provision.agreements : [];
        return agreements.filter((agreement: Agreement) => this.isAgreementSchedulableForProvisionFee(agreement, provisionFee, provision?.practice));
    }

    openDialogCalendar(title: string, component, style: { minWidth: string, maxHeight: string }, afterClosed?): void {
        this._dialogRefPopUpAddAttentions = this.dialog.open(component, {
            minWidth: style.minWidth,
            maxHeight: style.maxHeight,
            data: { template: this.scheduleDialogTemplate, title },
        });

        this._dialogRefPopUpAddAttentions.afterClosed().subscribe((result) => {
            // Ejecuta callback original
            if (afterClosed) afterClosed(result);

            // Asegura reset aunque se cierre con ESC / backdrop / closeAll()
            this.resetModuleDialogSelections();
        });
    }

    onSelectedCaseModuleAgreement(ag: Agreement, provision: Provision, pf: ProvisionFee) {
        let agreementSelected = ag;
        let provisionSelected = provision;
        let provisionFeeSelected = { ...pf, practice: provisionSelected.practice };
        agreementSelected.provision = provisionSelected;
        agreementSelected.provisionFeeId = pf?.id ?? provision.provisionFeeId;
        agreementSelected.practice = provisionSelected.practice;
        this.agreementSelected = agreementSelected;
        this.caseModuleAgreementId = ag.id;
        this.provisionSelected = provisionSelected;
        this.agreementSelected = agreementSelected;
        this.provisionFeeSelected = provisionFeeSelected;
        this.onSelectedAgreement(ag.id);
        // let filters: ProvisionAgreementFilters = {
        //     caseModuleIds: [this.selectedCaseModuleId$.value],
        //     provisionFees: [provisionFeeSelected],
        //     agreements: [agreementSelected],
        //     provisions: [provisionSelected],
        //     provisionsSupplies: [],
        //     provisionAgreementsSupplies: [],
        //     orders: [],
        //     modulesFlow: true
        // }
        // this.provisionsFacade.setFiltersOnProvisions(filters);

        // Asegurar que provisionFeeId sobreviva si onSelectedAgreement reemplazó agreementSelected
        if (this.agreementSelected && this.agreementSelected.provisionFeeId == null) {
            this.agreementSelected.provisionFeeId = pf?.id ?? provision.provisionFeeId;
        }

        // // Reconstruir calendario filtrado por esta práctica y acuerdo
        this.rebuildMonthEventsFromFilter();
        // this.rebuildModuleCalendarAndList();
    }

    onSelectedAgreement(agreementId: number) {
        this.moduleAttentionSelected = false;
        this.billingModuleAttentionSelected = false;
        // Restaurar validadores del modo acuerdo
        this.setAgreementModeFormValidators();
        // agreement selected
        this.onCleanAttentions(); // Always after select agreement
        this.resetForm();
        this.resetValuesDialog(false, false);
        this.dateSelectedFromOtherComponent = null;

        // In modules flow, the agreement can be pre-set via onSelectedCaseModuleAgreement
        // but it might not exist inside `this.agreements` (computed from provisions).

        const selectedAgreement = this.agreements?.find(agreement => agreement.id == agreementId) ?? this.agreementSelected;
        if (!selectedAgreement) {
            return;
        }

        this.agreementSelected = selectedAgreement;
        this.agreementForm = this.agreementSelected.id

        const rangeIntersection = this.getProvisionAgreementIntersectionRange(this.provisionFeeSelected, this.agreementSelected);
        if (!rangeIntersection) {
            this.agreementSelected = null;
            this.agreementForm = null;
            this.minDate = null;
            this.maxDate = null;
            this.dateEndRepeatForm = null;
            this.alertService.openInfo('El acuerdo seleccionado no comparte vigencia con la prestación y no puede agendarse.');
            return;
        }

        this.minDate = rangeIntersection.start.toDate();
        this.maxDate = rangeIntersection.end.toDate();


        const newDate: Date = moment(this.maxDate).isAfter(moment().add(6, 'months')) ? moment(moment().add(6, 'months')).toDate() : this.maxDate;
        this.dateEndRepeatForm = newDate;

        if (!this.activeAttention) {
            this.stateAttentionForm = this.ATTENTION_STATES.REALIZADA;
            if (this.agreementSelected.practice.restriction.requiredToDate) {
                // Setting all validators to time pickers
                this.scheduleForm.get(this.TIME_FROM).setValidators(Validators.compose([CustomValidators.required('Requerido'), CustomValidators.hourFormat('Inválido')]));
                this.scheduleForm.get(this.TIME_TO).setValidators(Validators.compose([CustomValidators.required('Requerido'), CustomValidators.hourFormat('Inválida')]));
                this.scheduleForm.get(this.HOUR_DURATION).setValidators(Validators.compose([CustomValidators.minValue(0, 'Duración inválida'), CustomValidators.maxValue(24, 'Superó las 24 hs.')]));
            } else {
                this.scheduleForm.get(this.TIME_FROM).setValidators([]);
                this.scheduleForm.get(this.TIME_TO).setValidators([]);
                this.scheduleForm.get(this.HOUR_DURATION).setValidators([]);
            }
        }

        if (!!this.dateSelectedFromOtherComponent && moment(this.dateSelectedFromOtherComponent).isBetween(this.minDate, this.maxDate, undefined, '[]')) {
            this.onSelectDate(moment(this.dateSelectedFromOtherComponent));
        }
        // agreement selected - debug removed
    }

    setAgreementToForm() {
        // populate form with selected agreement
        this.allPatientsDialog = [this.activeAttention.patient];
        this.allAgreementsDialog = this.provisions?.filter(prov => !prov.isSupply).flatMap(provision => provision.agreements).filter((ag) => !!ag); // Filtered supplies and attention "Entrega insumos"
        this.allAgreementsDialog = this.allAgreementsDialog.filter(agreement => (agreement.provider.id == this.activeAttention.provider.id));
        // this.providerForm = this.activeAttention.provider.id;
        this.patientForm = this.activeAttention.patient.id;
        this.agreementForm = this.activeAttention.agreementId;
        this.dateFromForm = this.activeAttention.fromDate;
        this.dateToForm = this.activeAttention.toDate;
        this.stateAttentionForm = this.activeAttention.state.id;
    }

    onCleanAttentions() {
        // clear selected attentions
        this.datesToPostSelected = [];
        this.isRepeatSchedule = false;
        this.setDayChipsSelected();
        this.sortAscArrayDates(this.datesToPostSelected); // Ordeno el array
        // this.minDate = null;
        // this.maxDate = null;
    }

    sortAttentions(attentions: Attention[]): Attention[] {
        attentions.sort((a, b) => new Date(a.fromDate).getTime() - new Date(b.fromDate).getTime());
        return attentions;
    }

    setDayChipsSelected() {
        this.dayChipsSelected.set('L', false);
        this.dayChipsSelected.set('M', false);
        this.dayChipsSelected.set('X', false);
        this.dayChipsSelected.set('J', false);
        this.dayChipsSelected.set('V', false);
        this.dayChipsSelected.set('S', false);
        this.dayChipsSelected.set('D', false);
    }

    // !Mutable
    // Ordena un array de moments, de manera ascendente (mas vieja primero)
    sortAscArrayDates(array: moment.Moment[]) {
        array.sort(function (a: moment.Moment, b: moment.Moment) {
            const a2 = a.toDate();
            const b2 = b.toDate();
            return a < b ? -1 : a > b ? 1 : 0;
        });
    }

    // Actualiza el valor del formulario "DateFromForm" en caso de que corresponda
    updateDateFromForm() {
        // update dateFrom form when needed
        // Si no hay fechas en el array o la fecha mas antigua del array es distinta a la del form modifico el form
        if (!this.activeAttention && (!this.datesToPostSelected[0]
            || new Date(this.datesToPostSelected[0].toDate()).getTime() != new Date(this.dateFromForm).getTime())) {
            this.dateFromForm = !!this.datesToPostSelected[0] ? this.datesToPostSelected[0].toDate() : null;
        }
    }

    canSelectDates(): boolean {
        return !!this.agreementSelected || (this.isModulesFlow && this.moduleAttentionSelected);
    }

    compareCaseModule = (a: CaseModuleComposed, b: CaseModuleComposed): boolean =>
        Number(a?.id) === Number(b?.id);

    trackByCaseModuleId(index: number, cm: CaseModuleComposed) {
        return cm?.id ?? index;
    }


    onSelectDate(date: moment.Moment) {
        if (!this.canSelectDates()) return;
        if (this.disableDay(date.toDate())) return;

        const keep = this.scheduleForm
            ? {
                stateAttention: this.scheduleForm.get(this.STATE_ATTENTION)?.value,
                repeatAttention: this.scheduleForm.get(this.REPEAT_ATTENTION)?.value,
                dateEndRepeat: this.scheduleForm.get(this.DATE_END_REPEAT)?.value,
                timeFrom: this.scheduleForm.get(this.TIME_FROM)?.value,
                timeTo: this.scheduleForm.get(this.TIME_TO)?.value,
                hourDuration: this.scheduleForm.get(this.HOUR_DURATION)?.value,
                minuteDuration: this.scheduleForm.get(this.MINUTE_DURATION)?.value,
            }
            : null;

        const normalized = moment(date).set({ hour: 0, minute: 0, second: 0, millisecond: 0 });

        const index = this.datesToPostSelected.findIndex(d => moment(d).isSame(normalized, 'day'));

        // FIX: NO mutar con splice (evita efectos colaterales de render / change detection)
        if (index > -1) {
            this.datesToPostSelected = this.datesToPostSelected.filter((_, i) => i !== index);
        } else {
            this.datesToPostSelected = [...this.datesToPostSelected, normalized];
        }

        this.sortAscArrayDates(this.datesToPostSelected);
        this.updateDateFromForm();

        if (this.datesToPostSelected.length === 0) {
            this.dateFromForm = null;
        }

        if (keep && this.scheduleForm) {
            // Reafirmar valores (sin emitir)
            this.scheduleForm.patchValue(
                {
                    [this.STATE_ATTENTION]: keep.stateAttention,
                    [this.REPEAT_ATTENTION]: keep.repeatAttention ?? String(this.repeatAttention ?? 1),
                    [this.DATE_END_REPEAT]: keep.dateEndRepeat,
                    [this.TIME_FROM]: keep.timeFrom,
                    [this.TIME_TO]: keep.timeTo,
                    [this.HOUR_DURATION]: keep.hourDuration,
                    [this.MINUTE_DURATION]: keep.minuteDuration,
                },
                { emitEvent: false }
            );

            // Y mantener sincronizado el default del selector visual
            const v = this.scheduleForm.get(this.REPEAT_ATTENTION)?.value;
            const n = Number(v);
            if (!Number.isNaN(n) && n > 0) {
                this.repeatAttention = n;
                this.defaultValueRepeatAttention = n;
            }
        }
    }

    deleteDatesUntil(dateUntil) {
        dateUntil = moment(dateUntil);
        this.datesToPostSelected = this.datesToPostSelected.filter(adate => adate.isSameOrBefore(dateUntil));
        // dates trimmed until
    }

    /**
     *
     * @param continueCreating
     * @param mode '', 'CPY'
     * @param hourFromCopy
     * @param hourToCopy
     */
    onCreateAttentionV2(continueCreating: boolean = false, mode?: string, fromDateCopy?: Date, hoursCopy?: number, minutesCopy?: number, stateIdCopy?: number) {
        let caseModuleId: number = null;
        if (!!this.caseModuleSelected) {
            caseModuleId = this.caseModuleSelected.id;
        }

        // SOLO facturable de módulo (root caseModuleId)
        const shouldSendCaseModuleId =
            this.isModulesFlow &&
            this.moduleAttentionSelected === true &&
            this.billingModuleAttentionSelected === true &&
            !!caseModuleId;

        let attentionsToPost: { agreementId?: number, fromDate: Date, toDate: Date, stateId: number, quantity?: number, caseId: number, expand: string[], caseModuleId?: number }[];
        this.loadingCreateAttention = true;

        if (!!this.agreementSelected) {
            if (!!this.agreementSelected.practice && this.agreementSelected?.practice.restriction.requiredToDate && this.agreementSelected.practice.restriction.requiredTime) {
                // GUARDIA - GUARD
                const hourFrom = !!mode && mode === 'CPY' ? moment(fromDateCopy).hours() : Number(this.timeFromForm[0] + this.timeFromForm[1]);
                const minuteFrom = !!mode && mode === 'CPY' ? moment(fromDateCopy).minutes() : Number(this.timeFromForm[3] + this.timeFromForm[4]);
                attentionsToPost = this.datesToPostSelected.map(dateToPost => {

                    const fromDate = moment(dateToPost);
                    fromDate.set({ hour: hourFrom, minute: minuteFrom });
                    const toDate = moment(fromDate);

                    let hourDurationForm;
                    let minuteDurationForm;

                    if (mode != 'CPY') {
                        hourDurationForm = this.hourDurationForm
                        minuteDurationForm = this.minuteDurationForm
                    } else {
                        hourDurationForm = hoursCopy
                        minuteDurationForm = minutesCopy
                    }



                    toDate.add(hourDurationForm, 'hour');
                    toDate.add(minuteDurationForm, 'minute');

                    const stateIdAux = mode != 'CPY' ? this.stateAttentionForm : stateIdCopy;
                    return {
                        agreementId: this.agreementSelected.id,
                        stateId: stateIdAux,
                        caseModuleId: this.caseModuleSelected?.id ?? null,
                        fromDate: fromDate.toDate(),
                        toDate: toDate.toDate(),
                        provisionFeeId: !!this.caseModuleAgreementId ? (this.provisionFeeSelected?.id ?? this.agreementSelected?.provisionFeeId) : this.provisionFeeForm,
                        quantity: [this.ATTENTION_STATES.REALIZADA, this.ATTENTION_STATES.FACTURABLE].includes(parseFloat(stateIdAux.toString())) ? this.calcHours(hourDurationForm, minuteDurationForm) : null,
                        caseId: this.case.id,
                        expand: ['provider', 'practice', 'patient', 'financier'],
                    };
                });
            } else {
                // VISITA - VISIT
                attentionsToPost = this.datesToPostSelected.map(dateToPost => {
                    return {
                        agreementId: this.agreementSelected.id,
                        caseModuleId: this.caseModuleSelected?.id ?? null,
                        stateId: this.stateAttentionForm,
                        fromDate: dateToPost.toDate(),
                        toDate: null,
                        provisionFeeId: !!this.caseModuleAgreementId ? (this.provisionFeeSelected?.id ?? this.agreementSelected?.provisionFeeId) : this.provisionFeeForm,
                        caseId: this.case.id,
                        expand: ['provider', 'practice', 'patient', 'financier'],
                    };
                });

                if (this.repeatAttention > 1) {
                    attentionsToPost = this.repeatAttentions(attentionsToPost, this.repeatAttention)
                }
            }

        }

        else if (this.caseModuleSelected && this.moduleAttentionSelected) {
            let toDateValue = null;
            attentionsToPost = this.datesToPostSelected.map(dateToPost => {
                return {
                    fromDate: dateToPost.toDate(),
                    toDate: toDateValue, stateId: this.stateAttentionForm,
                    caseId: this.case.id,
                    caseModuleId: this.caseModuleSelected?.id ?? null,
                    expand: ['provider', 'practice', 'patient', 'financier'],
                    ...(shouldSendCaseModuleId ? { caseModuleId } : {})
                };
            });

            if (this.repeatAttention > 1) {
                attentionsToPost = this.repeatAttentions(attentionsToPost, this.repeatAttention)
            }

        }

        this.postAttentionV2(attentionsToPost)
            .then(attention => {
                // Si se agendó una atención de módulo, sincronizar inmediatamente el calendario/listado de módulos. TODO: cambiar
                if (this.caseModuleSelected && this.moduleAttentionSelected) {
                    this.syncModuleAttentionsFromPostResponse(attention);
                    this.rebuildModuleCalendarAndList();
                    // Recargar provisions para que caseModulesComposed se actualice con las nuevas prácticas
                    this.provisionsFacade.loadAllProvisionsForCase(this.case.id);
                }
                if (mode != 'CPY') {
                    Swal.fire({
                        text: 'Agenda actualizada correctamente',
                        icon: 'success',
                        timer: 2500,
                        showConfirmButton: false
                    });
                }
            })
            .then(_ => {
                if (continueCreating) {
                    this.onCleanAttentions();
                    this.resetValuesDialog(false, false);
                    this.dateSelectedFromOtherComponent = null;
                    this.agreementsExpanded.select(attentionsToPost[0].agreementId)
                    this.loadingCreateAttention = false
                } else {
                    this.loadingCreateAttention = false
                    this._dialogRefPopUpAddAttentions.close();
                }
            })
            .catch(err => {
                if (err?.status == 418) {
                    let msgType: SweetAlertIcon;
                    let force = true;
                    // Error 418 handled
                    this.errorContent = err.error;
                    this.generalService.processErrorTeaPot(this.errorContent, this.createString, msgType).then((res) => {
                        if (!res) {
                            this.loadingCreateAttention = false
                        } else {
                            this.postAttentionV2(attentionsToPost, force).then(attention => {
                                if (this.caseModuleSelected && this.moduleAttentionSelected) {
                                    this.syncModuleAttentionsFromPostResponse(attention);
                                    this.rebuildModuleCalendarAndList();
                                    // Recargar provisions para que caseModulesComposed se actualice con las nuevas prácticas
                                    this.provisionsFacade.loadAllProvisionsForCase(this.case.id);
                                }
                                Swal.fire({
                                    text: 'Agenda actualizada correctamente',
                                    icon: 'success',
                                    timer: 2500,
                                    showConfirmButton: false
                                });
                            })
                                .then(_ => {
                                    if (continueCreating) {
                                        this.onCleanAttentions();
                                        this.resetValuesDialog(false, false);
                                        this.dateSelectedFromOtherComponent = null;
                                        this.agreementsExpanded.select(attentionsToPost[0].agreementId)
                                        this.loadingCreateAttention = false
                                    } else {
                                        this.loadingCreateAttention = false
                                        this._dialogRefPopUpAddAttentions.close();
                                    }
                                })
                        }
                    })
                } else {
                    this.loadingCreateAttention = false
                }

            })
    }

    createString(value: string): string {
        return value
    };

    resetValuesDialog(resetAgreementForm, resetAgreementSelected) {
        // reset dialog values

        this.allAgreementsDialog = [];
        this.allPatientsDialog = [];
        this.patientForm = null;

        this.agreementForm = resetAgreementForm ? null : this.agreementForm;
        this.agreementSelected = resetAgreementSelected ? null : this.agreementSelected;
        this.dateEndRepeatForm = resetAgreementSelected ? null : this.dateEndRepeatForm;
        this.minDate = resetAgreementSelected ? null : this.minDate;
        this.maxDate = resetAgreementSelected ? null : this.maxDate;

        this.timeFromForm = null;
        this.timeToForm = null;
        this.hourDurationForm = null;
        this.minuteDurationForm = null;

        this.repeatAttentionForm = null;
        this.isNextDay = false;
        // TODO: delete after production
        // I'm sotb, I know it
        // setTimeout(() => {
        //     this.agreementSelected = null; // If it's not exist this line then -> bug to app-date-picker called DATE_END_REPEAT (properties min & max)
        // }, 100);
    }

    resetForm() {
        // reset form
        this.datesToPostSelected = this.datesToPostSelected.filter(date => this.datesToPostSelected.indexOf(date) == 0);
        this.setDayChipsSelected();
        this.isRepeatSchedule = false;
        this.defaultValueRepeatAttention = 1;
        this.repeatAttention = 1;
        this.defaultValueStateAttention = AttentionStates.REALIZADA
        // this.timeToForm = null; // TODO: se hacen en resetValuesDialog()
        // this.timeFromForm = null;
        // this.hourDurationForm = null;
        // this.minuteDurationForm = null;
    }

    // postAttention(attentions: { fromDate: Date, toDate: Date, stateId: number, agreementId: number, provisionFeeId?: number }[], force?: boolean): Promise<Attention> {
    //     if (force) {
    //         return this.attentionsFacade.postAttentions(attentions, force).toPromise()
    //     } else {
    //         return this.attentionsFacade.postAttentions(attentions).toPromise();
    //     }
    // }

    postAttentionV2(attentions: { fromDate: Date, toDate: Date, stateId: number, agreementId?: number, provisionFeeId?: number, caseId: number, expand: string[], caseModuleId?: number }[], force?: boolean): Promise<Attention> {
        if (force) {
            return this.attentionsFacade.postAttentionsV2(attentions, force).toPromise();
        } else {
            return this.attentionsFacade.postAttentionsV2(attentions).toPromise();
        }
    }

    resetModuleDialogSelections(): void {
        // Solo aplica al flujo módulos
        if (!this.isModulesFlow) return;

        // Reset de "selección recordada"
        this.caseModuleSelected = null;
        this.selectedCaseModuleId$.next(null);

        this.provisionFeeSelected = null;
        this.agreementSelected = null;
        this.caseModuleAgreementId = null;

        // Estado de UI asociado
        this.moduleAttentionSelected = false;
        this.billingModuleAttentionSelected = false;
        this.isRepeatSchedule = false;

        // Limpieza SOLO de lo interno del dialog (no del calendario principal)
        this.modulesMonthEvents = [];

        // Si querés además resetear chips/fechas del dialog:
        this.datesToPostSelected = [];
        this.dayChipsSelected?.clear();

        // Rango fechas del selector (para que no quede condicionado por lo anterior)
        this.minDate = null;
        this.maxDate = null;

        // IMPORTANTE: volver a armar lo que ve el calendario principal (no dejarlo vacío)
        this.rebuildModuleCalendarAndList();
    }

    onClickCloseDialog() {
        this._dialogRefPopUpAddAttentions?.close();

        this.scheduleForm?.reset();
        this.agreementsExpanded.clear();
        this.dateSelectedFromOtherComponent = null;
        this.datesToPostSelected = [];
        this.dayChipsSelected.clear();

        // Esto ya lo tenías:
        this.moduleAttentionSelected = false;
        this.agreementSelected = null;

        // NUEVO: reset fuerte de selecciones del flujo módulos
        this.resetModuleDialogSelections();
    }

    // Metodo que se llama cuando se selecciona o se deselecciona un day chip
    selectDayChip(day: { key, value }) {
        // Actualizo la vista de los chips
        this.dayChipsSelected.set(day.key, !this.dayChipsSelected.get(day.key));
        // Actualizo el value del dia que me vino (por la accion anterior)
        day.value = this.dayChipsSelected.get(day.key);
        // Obtengo el dia en numero (antes estaba como L,M,X,J...)
        let numberDay = this.getDayChipNumber(day);
        // Obtengo el array de dias de ese día (chip) específico que se selecciono/deselecciono
        const daysOfDayChip: moment.Moment[] = this.dateService.recurDaysOfWeek(this.dateFromForm, this.dateEndRepeatForm, [numberDay]);
        // Inserto los días en el array de dias base (si el day chip fue seleccionado, es decir day.value == true)
        // o elimino los días en el array de dias base (si el day chip fue deseleccionado, es decir day.value == false)
        this.updateDatesToPostSelected(daysOfDayChip, day.value);
        // Si ese dia fue seleccionado
        // Ordeno el array
        this.sortAscArrayDates(this.datesToPostSelected);
        // Actualizo el dateFormFrom si es necesario
        this.updateDateFromForm();
        // this.calendarToPost ? this.calendarToPost.updateTodaysDate() : null;
    }

    // Metodo llamado para actualizar el array de dias (agregar/eliminar dias segun los que ya están y los nuevos)
    updateDatesToPostSelected(newDays: moment.Moment[], insert: boolean) {
        // Si se deben agregar los dias
        if (insert) {
            // Los dias que no estén los agrego
            newDays.forEach((newDay: moment.Moment) => {
                const indexNewDayOnOriginalArray = this.datesToPostSelected.findIndex(adate => adate.isSame(newDay, 'day'));
                if (indexNewDayOnOriginalArray == -1) {
                    this.datesToPostSelected.push(newDay);
                }
            });
        }
        // Si se deben quitar los dias
        else {
            // Recorro y borro los días que sean iguales
            newDays.forEach((dayToDelete: moment.Moment) => {
                const indexDayToDeleteOnOriginalArray = this.datesToPostSelected.findIndex(adate => adate.isSame(dayToDelete, 'day'));
                if (indexDayToDeleteOnOriginalArray != -1) {
                    this.datesToPostSelected.splice(indexDayToDeleteOnOriginalArray, 1);
                }
            });
        }
    }

    // Retorna en número el dia pasado como argumento (key: "L", "M"... value: true/false)
    getDayChipNumber(day: { key, value }): number {
        const dayChipMap = new Map<string, number>([
            ['D', 0],
            ['L', 1],
            ['M', 2],
            ['X', 3],
            ['J', 4],
            ['V', 5],
            ['S', 6],
        ]);

        return dayChipMap.get(day.key);
    }

    isDayChipSelected(day) {
        return this.dayChipsSelected.get(day);
    }

    asIsOrder(a, b) {
        return 1;
    }

    onChangeCheckRepeatSchedule(event) {
        // change repeat schedule
        this.isRepeatSchedule = event.checked;

        if (event.checked) {
            this.dateEndRepeatForm = moment(this.dateFromForm).add(1, 'months').date(0).toDate();
            this.setDayChipsSelected();

            if (!!this.maxDate) {
                const newDate: Date = moment(this.maxDate).isAfter(moment().add(6, 'months')) ? moment(moment().add(6, 'months')).toDate() : this.maxDate;
                this.scheduleForm.get(this.DATE_END_REPEAT).setValue(newDate);
            }
        } else {
            //this.dateEndRepeatForm = null;
            this.datesToPostSelected = this.datesToPostSelected.filter(date => this.datesToPostSelected.indexOf(date) == 0);
            // this.calendarToPost ? this.calendarToPost.updateTodaysDate() : null;
        }
    }

    // Retorna si el día del mat-calendar está en el array de los dates seleccionados (datesToPostSelected)
    // Es llamado desde el html, en el mat-calendar
    isSelectedDate = (date: moment.Moment) => {
        return this.datesToPostSelected.find((x: moment.Moment) => x.isSame(date, 'day')) ? true : false;
    }

    calculateIdPractice(element: Practice) {
        return element ? element.id : null;
    }

    calculateNamePractice(element: Practice) {
        return element ? element.name : null;
    }

    calculateIdProvider(element: Provider) {
        return element ? element.id : null;
    }

    calculateNameProvider(element: Provider) {
        return element ? `${element?.surname + ' ' + element?.name}` : null;
    }

    calculateNamePatient(element: Patient) {
        return element ? element.surname + ' ' + element.name : null;
    }

    calculateNameAgreement(element: Agreement): string {
        return element
            && element.practice
            && element.practice.name
            ? element.practice.name + ' - ' + (element.provision?.fee ? element.provision.fee : '')
            : 'Sin datos';
    }

    calculateNameState(element: StateAttention) {
        return element ? element.name : null;
    }

    calculateIdState = (element: StateAttention) => {
        return element ? element.id : null;
    }

    calculateNameAttentionRepeat(element: number) {
        return element
            ? element == 1 ? `${element} vez al día` : `${element} veces al día`
            : null;
    }

    calculateIdAttentionRepeat = (element: number) => {
        return element ? element : null;
    }

    calculateAgreementId(agreement: Agreement) {
        return agreement.id;
    }

    // trackBy functions to reduce DOM re-creation on ngFor
    trackByAgreementId(index: number, agreement: Agreement) {
        return agreement?.id ?? index;
    }

    trackByAttentionId(index: number, attention: Attention) {
        return attention?.id ?? index;
    }

    trackByEventIndex(index: number, event: any) {
        // calendar events may not have stable ids, use index as fallback
        return event?.meta?.attention?.id ?? index;
    }

    // Date helpers to avoid heavy moment(...) calls in hot paths
    private addHours(date: Date | string | number, hours: number): Date {
        const base = new Date(date);
        return new Date(base.getTime() + hours * 60 * 60 * 1000);
    }

    private coerceValidDate(value: any): Date | null {
        if (value == null) return null;
        const d = new Date(value);
        if (isNaN(d.getTime())) return null;
        // new Date(0) shows as 31/12/1969 in GMT-3 and triggers angular-calendar warnings.
        if (d.getTime() === 0) return null;
        return d;
    }

    private getSafeCalendarEndForAttention(attention: any): Date {
        const fromDate = this.coerceValidDate(attention?.fromDate) ?? new Date();
        const fromScheduled = this.coerceValidDate(attention?.fromScheduled);
        const startMax = new Date(Math.max(fromDate.getTime(), fromScheduled?.getTime() ?? fromDate.getTime()));

        const candidates = [
            this.coerceValidDate(attention?.toDateAdjusted),
            this.coerceValidDate(attention?.toDate),
            this.coerceValidDate(attention?.toScheduled),
        ].filter(Boolean) as Date[];

        let end = candidates.reduce((max, current) => (current.getTime() > max.getTime() ? current : max), candidates[0]);

        if (!end) {
            end = this.addHours(startMax, 1);
        }

        if (end.getTime() < startMax.getTime()) {
            end = this.addHours(startMax, 1);
        }

        return end;
    }

    private sanitizeAttentionsForCalendar(attentions: Attention[]): Attention[] {
        return (attentions ?? []).map((att) => {
            const safeEnd = this.getSafeCalendarEndForAttention(att as any);
            // Clone so we don't mutate the same attention used by list/table components.
            // app-calendar-case prioritizes toDateAdjusted, so set a safe value there.
            return {
                ...(att as any),
                toDateAdjusted: safeEnd,
            } as Attention;
        });
    }

    private normalizeEventEnd(attention: any, start: Date): Date {
        const startDate = start instanceof Date ? start : new Date(start);

        const candidateRaw = attention?.toDateAdjusted ?? attention?.toDate ?? null;
        const candidate = candidateRaw != null ? new Date(candidateRaw) : null;

        // Algunos backends envían 0 / null; new Date(0) en GMT-3 se ve como 31/12/1969 21:00.
        // Tratar epoch/invalid como "sin end".
        const isInvalid = !candidate || isNaN(candidate.getTime());
        const isEpoch = !isInvalid && candidate.getTime() === 0;

        let end = (!isInvalid && !isEpoch) ? candidate : this.addHours(startDate, 1);

        // Garantía final: angular-calendar warning si start > end.
        if (end.getTime() < startDate.getTime()) {
            end = this.addHours(startDate, 1);
        }
        return end;
    }

    private dayStartTs(date: Date | string | number): number {
        const d = new Date(date);
        d.setHours(0, 0, 0, 0);
        return d.getTime();
    }

    // Lightweight comparator for ProvisionAgreementFilters to avoid expensive JSON.stringify allocations.
    private filtersEqual(a: any, b: any): boolean {
        if (a === b) return true;
        if (!a || !b) return false;

        // Comparar flags booleanos/escalares primero (barato y crítico para cambios de modo agenda/facturar)
        const flagKeys = ['singleMode', 'modulesFlow', 'notManageable', 'onlyEntregaInsumos', 'onlyNonSupply'];
        for (const key of flagKeys) {
            if (!!a[key] !== !!b[key]) return false;
        }

        // Comparar arrays por longitud + IDs
        const arrayKeys = ['provisions', 'agreements', 'provisionFees', 'provisionsSupplies', 'provisionAgreementsSupplies', 'orders', 'caseModuleIds'];
        for (const key of arrayKeys) {
            const aa = a[key] || [];
            const bb = b[key] || [];
            if (aa.length !== bb.length) return false;
            if (aa.length === 0) continue;

            // Compare by id-ish fields when available to avoid deep equality
            const idsA = aa.map((it: any) => it?.id ?? (it?.provisionFeeId ?? JSON.stringify(it))).sort();
            const idsB = bb.map((it: any) => it?.id ?? (it?.provisionFeeId ?? JSON.stringify(it))).sort();
            for (let i = 0; i < idsA.length; i++) {
                if (idsA[i] !== idsB[i]) return false;
            }
        }

        return true;
    }

    calculateAgreementName(agreement: Agreement) {
        let result = (!!agreement.provider?.name || !!agreement.provider?.surname)
            ? agreement.provider.name + ' ' + agreement.provider.surname
            : ' - ';

        result += !!agreement.providerFee ? ' - $' + agreement.providerFee : ' - ';

        return result + ' - ' + (!!agreement.fromDate && !!agreement.toDate ? `${moment(agreement.fromDate).format('DD/MM/YYYY')} a ${moment(agreement.toDate).format('DD/MM/YYYY')}` : `${moment(agreement.fromDate).format('DD/MM/YYYY')}`);
    }

    onClickDeleteAttention(attention) {
        if (!this.isDeleteModeAttentionFromGridAgreements) {
            if (attention) {
                this.activeAttention = attention;
            } else {
                attention = this.activeAttention;
            }
        }

        this.swalWithCustomizeButtons.fire({
            text: '¿Seguro desea eliminar la atención?',
            icon: 'question',
            confirmButtonText: 'ELIMINAR',
            cancelButtonText: 'CANCELAR',
            showLoaderOnConfirm: true,
            showCancelButton: true,
            reverseButtons: true,
            preConfirm: () => {
                return this.deleteAttention(attention)
                    .then(_ => {
                        // !this.isDeleteModeAttentionFromGridAgreements ? this.onClickCloseDialog() : null; // Retrocompatible
                        this.swalWithCustomizeButtons.fire({
                            text: `Atención eliminada correctamente`,
                            icon: 'success',
                            timer: 2500,
                            showConfirmButton: false
                        })

                        if (!!this._dialogRefEditAttention.componentInstance) { // Action fired from another component
                            this._dialogRefEditAttention.close();
                        }
                    })
                    .catch(err => {
                        // !this.isDeleteModeAttentionFromGridAgreements ? this.onClickCloseDialog() : null; // Retrocompatible
                    });
            },
            allowOutsideClick: () => !Swal.isLoading()
        }).then(result => {
            if (result.dismiss === Swal.DismissReason.cancel) {
                // Not close previous window
            }
        })
    }

    deleteAttention(attention: Attention) {
        return this.attentionsFacade.deleteAttention(attention).toPromise();
    }

    filterCaseProviders(): Provider[] {
        const aux = this.provisions?.flatMap(provision => {
            if (!!provision.agreements) {
                return provision.agreements;
            }
        });
        const providers = aux?.map(agreement => {
            if (!!agreement && !!agreement.provider) {
                return agreement.provider;
            }
        }).filter(provider => !!provider) as Provider[];

        const providersSet: Provider[] = [];
        providers?.forEach(provider => {
            providersSet.find(prov => provider.id == prov.id) ? null : providersSet.push(provider);
        });

        return providersSet;
    }

    onEditAgreement(agreementId: number): void {

        this.agreementSelected = this.allAgreementsDialog.find(agreement => agreement.id == agreementId);
        if (!this.initialAgreementId && this.activeAttention.agreementId != agreementId) {
            this.initialAgreementId = this.activeAttention.agreementId;
        }
        this.activeAttention.agreementId = agreementId;
        this.activeAttention.practiceId = this.agreementSelected.practice.id;
        this.activeAttention.practice = this.agreementSelected.practice;
    }

    attentionDateEdited(event) {
        if (event) {
            this.radiobuttonsDisabled = true;
            this.selectionToUpdateValue = '';
            this.dateToForm = moment(this.dateFromForm).add(this.durationAttention, 'hours').toDate();
        }
    }

    attentionQuantityEdited() {
        this.dateToForm = moment(this.dateFromForm).add(this.durationAttention, 'hours').toDate();
    }

    composeAttentions(attentions: Attention[], agreements: Agreement[]): Attention[] {
        const attentionsComposed = attentions.map(attention => {
            let agreement = agreements?.find(agreement => agreement.id === attention.agreementId);
            if (agreement != null) {
                agreement['practice'] = attention.practice;
                // attention.patient = this.case.patient;
                attention.provider = agreement.provider;
            }
            return attention;
        });
        return attentionsComposed;
    }

    // setAttentionsOldAndOmitted() {
    //     let countAttentionOldAndOmmited: number = 0;
    //     this.attentions.forEach(at => {
    //         if (this.attentionsService.isOldAndOmmited(at)) {
    //             countAttentionOldAndOmmited += 1;
    //         }
    //     });
    //     if(!!this.case){
    //         this.case.attentionsOldAndOmitted = countAttentionOldAndOmmited;
    //     }
    // }
    setAttentionsOldAndOmitted() {
        let count = 0;
        this.attentions.forEach(at => { if (this.attentionsService.isOldAndOmmited(at)) count++; });

        if (this.case && 'attentionsOldAndOmitted' in this.case) {
            (this.case as Case).attentionsOldAndOmitted = count;
        }
    }

    // Process Bill or Debit
    onClickFacturableDebitada(attentions: Attention[], facturable: boolean) {
        let warningText: string;
        let warningTitle: string = 'Advertencia de cambio de estado fuera del flujo normal';
        let countAttentionsInStateDone: number = 0;
        let countAttentionsInStateNotDone: number = 0;
        let countAttentionsInStateBillable: number = 0;
        let countAttentionsInStateDebited: number = 0;
        let warningPopUp: Boolean = false;
        // Eliminamos las seleccionadas para pasarlas al mismo estado
        if (facturable) {
            attentions = attentions.filter(at => at.state.id != AttentionStates.FACTURABLE);
        } else {
            attentions = attentions.filter(at => at.state.id != AttentionStates.DEBITADA);
        }
        // Seteamos contadores de estado
        attentions.forEach((attention) => {
            if (attention.state.id == AttentionStates.REALIZADA) {
                countAttentionsInStateDone += 1;
            }
            if (attention.state.id == AttentionStates.NO_REALIZADA) {
                countAttentionsInStateNotDone += 1;
            }
            if (attention.state.id == AttentionStates.FACTURABLE) {
                countAttentionsInStateBillable += 1;
            }
            if (attention.state.id == AttentionStates.DEBITADA) {
                countAttentionsInStateDebited += 1;
            }

        });
        // Identificamos cambios de estado fuera del curso normal (debitada -> facturable | no realizada -> facturable | facturable -> debitada | realizada -> debitada)
        if (facturable && (countAttentionsInStateNotDone > 0 || countAttentionsInStateDebited > 0)) {
            warningPopUp = true;
            countAttentionsInStateNotDone > 0
                ? warningText = 'Tiene '
                + countAttentionsInStateNotDone
                + ' atención/es seleccionada/s en estado "No realizada". '
                : warningText = '';
            countAttentionsInStateDebited > 0
                ? warningText = warningText
                + 'Tiene ' + countAttentionsInStateDebited
                + ' atención/es seleccionada/s en estado "Debitada". '
                : warningText = '';
            warningText = warningText + 'Debe escribir un motivo para poder realizar el/los cambios de estado a "facturable".';
        } else {
            if (!facturable && (countAttentionsInStateDone > 0 || countAttentionsInStateBillable > 0)) {
                warningPopUp = true;
                countAttentionsInStateDone > 0
                    ? warningText = 'Tiene '
                    + countAttentionsInStateDone
                    + ' atención/es seleccionada/s en estado "Realizada". '
                    : warningText = '';
                countAttentionsInStateBillable > 0
                    ? warningText = warningText
                    + 'Tiene '
                    + countAttentionsInStateBillable
                    + ' atención/es seleccionada/s en estado "Facturable".'
                    : warningText = '';
                warningText = warningText + 'Debe escribir un motivo para poder realizar el/los cambios de estado a "debitada".';
            }
        }

        let pathFunction = (val) => {

            let st: string;
            const attentionsToPatch: Attention[] = attentions.map((at) => {
                let attention: Attention = {
                    id: at.id,
                    caseId: at.caseId,
                    state: {
                        id: facturable ? this.ATTENTION_STATES.FACTURABLE : this.ATTENTION_STATES.DEBITADA
                    }
                };
                if (this.isCrossState(at, facturable)) {
                    st = facturable ? 'Facturable' : 'Debitada';
                    const description: string = '(Cambio de "' + at.state.name + '" a "' + st + '") ' + val;
                    attention.crossStateDescription = description;
                }
                return attention;
            });
            return this.patchAttentions(attentionsToPatch)
                .then((attentionsResponse) => {
                    this.attentions = this.attentions?.map((attention) => {
                        const updatedAttention = attentionsResponse.find(
                            (att) => attention.id == att.id,
                        );
                        if (updatedAttention) {
                            attention = { ...attention, state: updatedAttention.state };
                        }
                        return attention;
                    });
                    // Re-load provisions
                    let provisionsFiltered = attentionsResponse.map(att => att.provisionId)

                    provisionsFiltered.filter((item, index) => {
                        return provisionsFiltered.indexOf(item) === index;
                    })

                    this.supplyList = this.supplyList?.map((supply) => {
                        const updatedSupply = attentionsResponse.find(
                            (att) => supply.id == att.id,
                        );
                        if (updatedSupply) {
                            supply = { ...supply, state: updatedSupply.state };
                        }
                        return supply;
                    });
                })
                .then((_) => {
                    this.swalWithCustomizeButtons.fire({
                        text: 'Atenciones modificadas correctamente',
                        icon: 'success',
                    }).then(_ => {
                        const executionType = this.canExecute$.value === 'bill' ? 'debit' : '';
                        this.canExecute$.next(executionType)
                        this.dialog.closeAll();
                    });
                })
                .catch((err) => {
                    this.swalWithCustomizeButtons.fire({
                        title: 'Atención',
                        icon: 'warning',
                        text: err.error.message,
                    })
                });
        };

        let title;
        let text;

        if (this.billSuppliesExternally?.length > 0) {
            title = 'Valor/es cargado/s con éxito.'
            text = '¿Desea completar el cambio de estado a “Facturable” de los insumos seleccionados?'
        } else {
            title = 'Atención'
            text = `¿Está seguro que desea modificar las atenciones seleccionadas al estado "${facturable ? 'Facturable' : 'Debitada'}" ?`
        }

        const sao: SweetAlertOptions = {
            icon: 'question',
            title: title,
            text: text,
            confirmButtonText: 'CONFIRMAR',
            cancelButtonText: 'CANCELAR',
            showLoaderOnConfirm: true,
            showCancelButton: true,
            reverseButtons: true,
            preConfirm: pathFunction,
            allowOutsideClick: () => !Swal.isLoading(),
        };

        // It's necessary to differentiate the case when there are supplies billed externally because they don't belong to any module, so the warning should be different.
        const nonModulePFsWithoutCostOrFee = this.provisionFeesWithoutCostOrFee.filter(pf => pf.caseModuleId == null);
        const modulePFsWithoutCost = this.provisionFeesWithoutCostOrFee.filter(pf => pf.caseModuleId != null && pf.cost == 0);

        if (warningPopUp) {
            this.swalWithCustomizeButtons.fire({
                icon: 'warning',
                title: warningTitle,
                text: warningText,
                input: 'textarea',
                inputPlaceholder: 'Escriba un motivo... ',
                inputValidator: (value) => {
                    if (value.length < 10) {
                        return 'El motivo debe tener más de 10 caracteres.';
                    }
                    return ''
                },
                confirmButtonText: 'CONFIRMAR',
                cancelButtonText: 'CANCELAR',
                showLoaderOnConfirm: true,
                showCancelButton: true,
                reverseButtons: true,
                preConfirm: pathFunction,
                allowOutsideClick: () => !Swal.isLoading(),
            });
        } else if (nonModulePFsWithoutCostOrFee.length != 0 && this.provisionFeesWithKairos.length == 0 && (!this.billSuppliesExternally || this.billSuppliesExternally?.length == 0)) {
            let arrayTable = nonModulePFsWithoutCostOrFee.map(sup => {
                return {
                    supplyName: sup?.practice?.name,
                    quantity: `${sup?.frequency?.amount} ${sup?.frequency?.unit}`,
                    provider: `${sup?.agreement?.provider?.name} ${sup?.agreement?.provider?.surname}`
                }
            })
            this._dialogRefSupply = this.dialog.open(MessageDialogComponent, {
                disableClose: false,
                maxHeight: '70vh',
                minWidth: '30%',
                data: {
                    arrayTable: arrayTable,
                    title: 'Atención',
                    icon: 'WarningCircle',
                    closeText: 'MODIFICAR',
                    confirmText: 'CONTINUAR',
                    message: 'Los siguientes insumos no poseen costo o valor venta, ¿Desea continuar?',
                }
            })
            this._dialogRefSupply.componentInstance.ok.subscribe(result => {
                if (result) {
                    pathFunction('').then(() => {
                        this._dialogRefSupply.close()
                        this.provisionFeesWithKairos = [];
                        this.provisionFeesWithoutCostOrFee = [];
                    })
                } else {
                    this.openModifySuppliesProvisionFee.emit(nonModulePFsWithoutCostOrFee.map(pF => pF.id))
                    this._dialogRefSupply.close()
                }
            })
        } else if (modulePFsWithoutCost.length != 0) {

            let arrayTable = modulePFsWithoutCost.map(sup => ({
                supplyName: sup?.practice?.name,
                quantity: `${sup?.frequency?.amount} ${sup?.frequency?.unit}`,
                provider: `${sup?.agreement?.provider?.name} ${sup?.agreement?.provider?.surname}`
            }));
            this._dialogRefSupply = this.dialog.open(MessageDialogComponent, {
                disableClose: false,
                maxHeight: '70vh',
                minWidth: '30%',
                data: {
                    arrayTable: arrayTable,
                    title: 'Atención',
                    icon: 'WarningCircle',
                    // closeText: 'MODIFICAR',
                    closeText: 'CANCELAR',
                    confirmText: 'CONTINUAR',
                    message: 'Los siguientes insumos no poseen costo, ¿Desea continuar?',
                }
            });
            this._dialogRefSupply.componentInstance.ok.subscribe(result => {
                if (result) {
                    pathFunction('').then(() => {
                        this._dialogRefSupply.close();
                        this.provisionFeesWithKairos = [];
                        this.provisionFeesWithoutCostOrFee = [];
                    });
                } else {
                    this.openModifySuppliesProvisionFee.emit(modulePFsWithoutCost.map(pF => pF.id))
                    this._dialogRefSupply.close();
                }
            });
        } else {
            this.swalWithCustomizeButtons?.fire(sao).then(() => this.dialog.closeAll());
        }
        this.billSuppliesExternally = [];
    }

    patchAttentions(attentions: PatchAttentionBody[]): Promise<Attention[]> {
        return new Promise((resolve, reject) => {
            this.attentionsFacade.patchAttentions(attentions).subscribe({
                next: (attresponse) => resolve(attresponse),
                error: (error) => reject(error),
            });
        });
    }

    isCrossState(at: Attention, facturable: boolean) {
        if (facturable && (at.state.id == AttentionStates.NO_REALIZADA || at.state.id == AttentionStates.DEBITADA)) {
            return true;
        } else {
            if (!facturable && (at.state.id == AttentionStates.NO_REALIZADA || at.state.id == AttentionStates.REALIZADA || at.state.id == AttentionStates.FACTURABLE)) {
                return true;
            } else {
                return false;
            }
        }
    }

    receiveEventUpdate(attention: Attention) {
        this.onEventClickedHandler({ calendarEvent: attention, editMode: 'DSP' });
    }

    receiveEventDelete(attention: Attention) {
        this.isDeleteModeAttentionFromGridAgreements = false;
        this.onClickDeleteAttention(attention);
    }

    receiveOptionSelected(option) {
        this.optionSelected = (option?.value ?? '').toString().toLowerCase();
        // Emitir al padre para que sepa si estamos en calendario o listado
        this.scheduleViewModeChanged.emit(this.optionSelected);
        if (option.value === 'listado' && this.isModulesFlow) {
            this.provisionAgreementsInput = {
                provisions: [],
                provisionFees: [],
                agreements: [],
                orders: [],
                provisionsSupplies: [],
                caseModuleIds: [],
                modulesFlow: true
            };

            this.provisionsFacade.setFiltersOnProvisions(this.provisionAgreementsInput);
        }
    }

    getCaseModuleNameMap(): Map<number, string> {
        const map = new Map<number, string>();
        (this.caseModules ?? []).forEach(cm => {
            if (cm?.id != null && typeof cm?.name === 'string') map.set(cm.id, cm.name);
        });
        return map;
    }

    rebuildModuleCalendarAndList(): void {
        if (!this.isModulesFlow) return;

        // Usar mamushkaCheckBoxesV2 para filtrar según los filtros de provisionAgreementsInput
        let composed: Attention[];
        if (this.provisionAgreementsInput) {
            // singleMode viene ya correctamente seteado por quien pushea los filtros
            // (modules-scheme via updateFilter, o provision-scheme via onClickBilling/onClickCalendar).
            // NO sobreescribir con la vista porque la subscription de filtros se ejecuta
            // antes de que Angular actualice los inputs de vista (optionSelected/signal).
            const filters: ProvisionAgreementFilters = {
                ...this.provisionAgreementsInput,
            };
            composed = this.attentionsService.mamushkaCheckBoxesV2(filters, this.attentions);
        } else {
            composed = this.filterUnifiedAttentionsAfterModuleComposition(this.attentions);
        }

        this.filteredAttentions = this.addCaseModuleName(composed);
        this.moduleAttentionsToEvents(composed);
    }

    /**
     * Filtra atenciones usando mamushkaCheckBoxesV2 y llena this.events / this.monthEvents
     * con el resultado convertido a CalendarEvent.
     */
    rebuildMonthEventsFromFilter(): void {
        const baseFilters = this.provisionAgreementsInput ?? {
            caseModuleIds: [],
            modulesFlow: true,
            provisionFees: [],
            provisions: [],
            agreements: [],
            provisionsSupplies: [],
            provisionAgreementsSupplies: [],
            orders: []
        };

        let filters: ProvisionAgreementFilters = {
            ...baseFilters,
            caseModuleIds: [this.caseModuleSelected.id],
            modulesFlow: true,
            provisionFees: this.provisionFeeSelected ? [this.provisionFeeSelected] : [],
            provisions: this.provisionSelected ? [this.provisionSelected] : [],
            // No filtrar por el agreement seleccionado del diálogo: mantener visibles
            // todas las atenciones de la provisionFee, como en el flujo clásico.
            agreements: baseFilters.agreements ?? [],
        }
        const filtered = this.attentionsService.mamushkaCheckBoxesV2(filters, this.attentions);
        // this.filteredAttentions = filtered;
        this.modulesMonthEvents = this.attentionsToEvents(filtered);
    }

    /**
     * Aplica filtros de provisionAgreementsInput a las atenciones.
     *
     * Lógica:
     * - Si no hay filtros activos (null/undefined) → devuelve todas
     * - Si provisions/provisionFees son arrays vacíos [] → mostrar SOLO atenciones tipo MODULE
     * - Si hay provisions/provisionFees con contenido → filtrar por provisionFeeId
     */
    private applyProvisionAgreementsFilter(attentions: Attention[]): Attention[] {
        const list = Array.isArray(attentions) ? attentions : [];

        // Si no hay filtro definido, devolver todo
        if (!this.provisionAgreementsInput) {
            return list;
        }

        const { provisions, provisionFees } = this.provisionAgreementsInput;

        // Verificar si hay filtros activos
        const hasProvisions = Array.isArray(provisions) && provisions.length > 0;
        const hasProvisionFees = Array.isArray(provisionFees) && provisionFees.length > 0;

        // Si ambos están vacíos (arrays []), puede significar:
        // - Módulos checked pero sin prácticas → mostrar solo atenciones tipo MODULE
        if (!hasProvisions && !hasProvisionFees) {
            // Verificar si hay módulos seleccionados (caseModuleIds con contenido)
            const hasModulesSelected = Array.isArray(this.provisionAgreementsInput.caseModuleIds) && this.provisionAgreementsInput.caseModuleIds.length > 0;

            if (hasModulesSelected) {
                // Módulos checked pero sin prácticas → solo mostrar atenciones tipo MODULE
                return list.filter(att => att?.type === AttentionType.MODULE);
            }

            // Sin ningún check → mostrar todo
            return list;
        }

        // Construir Set de provisionFeeIds permitidos
        const allowedProvisionFeeIds = new Set<number>();

        // Agregar provisionFeeIds directos
        if (hasProvisionFees) {
            for (const pf of provisionFees) {
                const pfId = (pf as any)?.id ?? (pf as any)?.provisionFeeId;
                if (pfId != null) {
                    allowedProvisionFeeIds.add(Number(pfId));
                }
            }
        }

        // Agregar provisionFeeIds de las provisions
        if (hasProvisions) {
            for (const prov of provisions) {
                const fees = (prov as any)?.provisionFees ?? [];
                for (const pf of fees) {
                    const pfId = (pf as any)?.id ?? (pf as any)?.provisionFeeId;
                    if (pfId != null) {
                        allowedProvisionFeeIds.add(Number(pfId));
                    }
                }
            }
        }

        // Filtrar atenciones
        return list.filter(att => {
            // Atenciones tipo MODULE (root) siempre pasan (ya filtradas por caseModuleIds)
            if (att?.type === AttentionType.MODULE) {
                return true;
            }
            // Atenciones con agreement (PRACTICE_MODULE) → filtrar por provisionFeeId
            const pfId = (att as any)?.provisionFeeId;
            if (pfId == null) {
                return false;
            }

            return allowedProvisionFeeIds.has(Number(pfId));
        });
    }

    addCaseModuleName(attentions: any[]): any[] {
        const modules = Array.isArray(this.caseModules) ? this.caseModules : [];
        const nameById = new Map<number, string>(
            modules
                .filter((m: any) => m?.id != null && typeof m?.name === 'string')
                .map((m: any) => [Number(m.id), String(m.name)])
        );

        const pfMap = this.getProvisionFeeCaseModuleIdByProvisionFeeId();

        return (attentions ?? []).map((att: any) => {
            const derivedId = this.getCaseModuleIdForAttention(att as Attention, pfMap);
            if (derivedId == null) return att;

            const cmName = nameById.get(Number(derivedId));
            return {
                ...att,
                caseModuleName: cmName ?? att?.caseModuleName ?? null,
            };
        });
    }


    private syncModuleAttentionsFromPostResponse(response: any): void {
        if (!response) return;
        const posted: Attention[] = Array.isArray(response) ? response : [response];
        const modulePosted = posted.filter(a => a?.caseModuleId != null && a?.id != null);
        if (modulePosted.length === 0) return;

        const current = Array.isArray(this.allModulesAttentions) ? this.allModulesAttentions : [];
        const byId = new Map<number, Attention>();
        for (const a of current) {
            if (a?.id != null) byId.set(a.id, a);
        }
        for (const a of modulePosted) {
            byId.set(a.id, a);
        }
        this.allModulesAttentions = Array.from(byId.values());
    }

    createAttentionFromOUT(event) {
        // let today = new Date();
        this.createAttentionFromOutside = true
        moment.updateLocale("es", {
            week: {
                dow: 0, // First day of week is Monday
                doy: 7  // First week of year must contain 4 January (7 + 1 - 4)
            }
        });

        switch (event.view) {

            case CalendarView.Day:
                // this.onClickCreateAttention(event.date); // Selected day
                this.onClickCreateAttention(); // Selected day
                break;

            case CalendarView.Week:
                this.onClickCreateAttention(); // Selected day
                // if (isSameWeek(event.date, today)) {
                //     this.onClickCreateAttention(today);
                // } else {
                //     const newDate = new Date(moment(event.date).startOf('week').toString()) // First day the week
                //     this.onClickCreateAttention(newDate);
                // }
                break;

            case CalendarView.Month:
                this.onClickCreateAttention();
                // if (isSameMonth(event.date, today)) {
                //     this.onClickCreateAttention();
                // } else {
                //     this.onClickCreateAttention();
                // }
                break;
            default:    // Nothing
                break;
        }
    }

    receiveStateAttentionsSelected(states: number[]) {
        this.stateAttentionSelected = states;
    }

    calculateProvisionFeeId = (provisionFee: ProvisionFeeWithPractice) => {
        return provisionFee.id;
    };

    private getProvisionFeeAllowedHoursLabel(provisionFee: ProvisionFee | ProvisionFeeWithPractice, practice?: Practice): string {
        const allowedHours = provisionFee?.frequency?.allowedHours;
        const resolvedPractice = practice ?? (provisionFee as ProvisionFeeWithPractice)?.practice;
        const isGuard = Number(resolvedPractice?.restriction?.id) === 2 || !!resolvedPractice?.restriction?.requiredTime;

        if (!allowedHours || !isGuard) {
            return '';
        }

        return `${allowedHours} ${allowedHours === 1 ? 'hora diaria' : 'horas diarias'}`;
    }

    private buildProvisionFeeName(
        provisionFee: ProvisionFee | ProvisionFeeWithPractice,
        practice?: Practice,
        options?: { includeFee?: boolean }
    ): string {
        const resolvedPractice = practice ?? (provisionFee as ProvisionFeeWithPractice)?.practice;
        const practiceName = resolvedPractice?.name ?? '';
        const includeFee = options?.includeFee ?? true;
        const fee = includeFee ? (!!provisionFee?.arrangementId ? 'Valor convenido' : `$${provisionFee?.fee}`) : '';
        const frecuencyAmount = provisionFee?.frequency?.amount ?? '';
        const frecuecyUnit = provisionFee?.frequency?.unit ?? '';
        const frecuency = !!frecuencyAmount && !!frecuecyUnit ? `${frecuencyAmount} por ${frecuecyUnit}` : '';
        const allowedHours = this.getProvisionFeeAllowedHoursLabel(provisionFee, resolvedPractice);
        const fromDate = !!provisionFee?.fromDate ? moment(provisionFee.fromDate).format('DD/MM/YYYY') : '';
        const toDate = !!provisionFee?.toDate ? moment(provisionFee.toDate).format('DD/MM/YYYY') : '';
        const vigency = !!fromDate && !!toDate ? `${fromDate} a ${toDate}` : fromDate;

        return [practiceName, fee, frecuency, allowedHours, vigency].filter(item => item !== '').join(' - ');
    }

    calculateProvisionFeeName = (provisionFee: ProvisionFeeWithPractice) => {
        if (this.editingCaseModuleAttention) {
            provisionFee = this.provisionFeeSelected;
        }
        return this.buildProvisionFeeName(provisionFee, provisionFee?.practice);
    };

    calculateCaseModuleProvisionFeeName = (provision: Provision, provisionFee: ProvisionFee) => {
        return this.buildProvisionFeeName(provisionFee, provision?.practice, { includeFee: false });
    };

    calculateCaseModuleName(caseModule: CaseModuleComposed) {
        let moduleName = !!caseModule?.name ? caseModule.name : '';
        let frecuency = !!caseModule?.frequency ? caseModule.frequency : '';
        let fee = !!caseModule.fee ? `$${caseModule.fee}` : '$ -';
        let vigency = !!caseModule.vigency ? caseModule.vigency.replace(/\s*-\s*/, ' a ') : '';
        let result = [moduleName, frecuency, fee, vigency]
            .filter(item => item !== '')
            .join(' ' + '-' + ' ');

        return result;
    }

    onSelectedProvisionFee(event: ProvisionFeeWithPractice) {
        this.onCleanAttentions();
        this.resetValuesDialog(true, true);

        this.provisionFeeSelected = event;

        // provision fee selected

        // this.view = CalendarView.Month;
        // this.CalendarView
        this.setButtonsToCalendarNavigate(this.view, this.generalService.getDateToSetCalendar());

        if (this.calendarCaseService.practiceCountedByHours(event.practice)) {
            this.scheduleForm.get(this.DATE_FROM).setValidators([CustomValidators.required('Fecha requerida')])
        } else {
            this.scheduleForm.get(this.DATE_FROM).setValidators([]);
        }
        this.mapCaseAgreements(event);
        this.events = this.attentionsToEvents(this.filteredAttentions);
        this.mapMonthEvents();
    }

    onSelectedCaseModule(event: any) {
        this.provisionsExpanded.clear();
        this.agreementsExpanded.clear();

        // Limpiar estado de filtrado para que el calendario muestre TODAS las atenciones del módulo
        this.billingModuleAttentionSelected = false;
        this.moduleAttentionSelected = false;
        this.caseModuleAgreementId = null;
        this.agreementSelected = null;
        this.provisionFeeSelected = null;

        // Acepta tanto objeto como id
        const incomingId = typeof event === 'number' || typeof event === 'string' ? Number(event) : Number(event?.id);
        const selected = (this.caseModules ?? []).find(cm => Number(cm?.id) === incomingId) ?? (event as CaseModuleComposed);

        this.caseModuleSelected = selected ?? null;
        this.selectedCaseModuleId$.next(this.caseModuleSelected?.id ?? null);

        this.onCleanAttentions();
        this.resetValuesDialog(true, true);

        this.view = CalendarView.Month;
        this.setButtonsToCalendarNavigate(this.view, this.generalService.getDateToSetCalendar());

        if (this.calendarCaseService.practiceCountedByHours(null)) {
            this.scheduleForm.get(this.DATE_FROM).setValidators([CustomValidators.required('Fecha requerida')]);
        } else {
            this.scheduleForm.get(this.DATE_FROM).setValidators([]);
        }

        // this.mapCaseModuleAgreements(this.caseModuleSelected);
        // En flujo módulos, NO usar el calendario de agreements (events/monthEvents).
        // La UI de módulos se alimenta con modulesMonthEvents/modulesBillingEvents.
        if (!this.isModulesFlow) {
            this.events = this.attentionsToEvents(this.attentions);
            this.mapMonthEvents();
        } else {
            this.events = [];
            this.monthEvents = [];
            this.ensureModuleAttentionsLoaded();
            this.maybeRebuildModuleView();
        }
    }

    private maybeRebuildModuleView(): void {
        if (!this.isModulesFlow) return;
        this.rebuildModuleCalendarAndList();
    }

    private ensureModuleAttentionsLoaded(): void {
        // module attentions are populated in ModulesState by AttentionsFacade.loadAttentionsGeneric
        if (!this.isModulesFlow) return;
        if (!this.case?.id) return;

        const fromDate = this.rangeToNavigate?.historyFromDate ?? this.dateRange?.historyFromDate;
        const toDate = this.rangeToNavigate?.historyToDate ?? this.dateRange?.historyToDate;

        if (!fromDate || !toDate) return;
        if (this.requestedModuleAttentionsForRange) return;
        this.requestedModuleAttentionsForRange = true;
        // let includeAttentionsCaseModules = true;

        // this.attentionsFacade
        //     .loadAttentionsGeneric({ casesIds: [this.case.id], fromDate, toDate, }, false)
        //     .subscribe({
        //         next: () => {
        //             // moduleAttentions$ will emit via ModulesState.setModuleAttentions
        //         },
        //         error: () => {
        //             // allow retry on next trigger
        //             this.requestedModuleAttentionsForRange = false;
        //         },
        //     });
    }


    ngOnDestroy(): void {

        if (!!this._screenToJump) {
            this._screenToJump.unsubscribe()
            this.breadcrumbService.setScreenToJump(null)
        }

        // schedule-case destroy

        if (!!this._canExecute)
            this._canExecute.unsubscribe();

        if (!!this._allProvisionsCase) {
            this._allProvisionsCase.unsubscribe();
        }

        this._historyModeDate ? this._historyModeDate.unsubscribe() : null;
        this._filtersOnProvisions ? this._filtersOnProvisions.unsubscribe() : null;
        this._provisionsDisplayedOnScreen ? this._provisionsDisplayedOnScreen.unsubscribe() : null;
        this._provisionsForCase ? this._provisionsForCase.unsubscribe() : null;
        this._scheduleFormDebugSub?.unsubscribe();
    }

    mustShowSpinner() {
        if (this.isLoadingGetAttentions || this.isLoadingGettingEvolutions) {
            return true;
        }
        return false;
    }

    setDatePicker(event) {
        if (!!event.value) {
            this.deleteDatesUntil(moment(event.value).toDate());

            for (let [key, value] of this.dayChipsSelected) {

                if (value === true) {
                    // Same logic as "selectDayChip" method, but without the toggle function
                    let numberDay = this.getDayChipNumber({ key, value });

                    const daysOfDayChip: moment.Moment[] = this.dateService.recurDaysOfWeek(this.dateFromForm, this.dateEndRepeatForm, [numberDay]);

                    this.updateDatesToPostSelected(daysOfDayChip, value);

                    this.sortAscArrayDates(this.datesToPostSelected);

                    this.updateDateFromForm();

                    // this.calendarToPost.updateTodaysDate();
                }
            }
        } else {
            this.dateEndRepeatForm = moment(this.dateFromForm).add(6, 'months').toDate();
        }
    }

    validateTimeValid() {
        let timeString = this.scheduleForm.get(this.TIME_FROM).value
        timeString = timeString.padEnd(4, '0')
        timeString = timeString.replace(/\D/g, '')
        if (timeString.length == 4) {
            if (parseInt(timeString) <= 2359) {
                let formattedTimeString = timeString.substring(0, 2) + ':' + timeString.substring(2,)
                this.scheduleForm.get(this.TIME_FROM).setValue(formattedTimeString)
                if (this.scheduleForm.get(this.TIME_TO).dirty) {
                    this.changeHourFinish();
                } else if (this.scheduleForm.get(this.HOUR_DURATION).dirty || this.scheduleForm.get(this.MINUTE_DURATION).dirty) {
                    this.durationChanged();
                }
            }
        }
    }

    changeHourFinish() {
        let timeString = this.scheduleForm.get(this.TIME_TO).value
        timeString = timeString.padEnd(4, '0')
        timeString = timeString.replace(/\D/g, '')
        let timeTo;
        if (timeString.length == 4) {
            if (parseInt(timeString) <= 2359) {
                let formattedTimeString = timeString.substring(0, 2) + ':' + timeString.substring(2,)
                this.scheduleForm.get(this.TIME_TO).setValue(formattedTimeString);

                let timeFrom = moment(this.scheduleForm.get(this.TIME_FROM).value, 'HH:mm')
                // Same day
                if (parseInt(timeString) > parseInt(this.timeFromForm.replace(':', ''))) {
                    timeTo = moment(this.scheduleForm.get(this.TIME_TO).value, 'HH:mm')
                    // Next day
                } else {
                    timeTo = moment(timeFrom).add(1, 'day')
                    timeTo = moment(timeTo).set({ hour: timeString.substring(0, 2), minute: timeString.substring(2,) })
                }

                let timeDifference = moment.duration(timeTo.diff(timeFrom))
                this.scheduleForm.get(this.HOUR_DURATION).setValue(timeDifference.asHours() >> 0);
                this.scheduleForm.get(this.MINUTE_DURATION).setValue(timeDifference.minutes());
            }
        }
        this.scheduleForm.get(this.HOUR_DURATION).markAsPristine();
        this.scheduleForm.get(this.MINUTE_DURATION).markAsPristine();
        this.validateIfNextDay();
        this.setMinutesToLimit();
    }

    durationChanged() {
        let hours = this.hourDurationForm;
        let minutes: any = hours != 24 ? this.minuteDurationForm : 0;
        let hourFinish = moment(this.scheduleForm.get(this.TIME_FROM).value, 'HH:mm').add({ hours: hours, minutes: minutes })
        if (hours != null && (minutes != null && minutes != "")) {
            this.scheduleForm.get(this.TIME_TO).setValue(hourFinish.format('HH:mm'));
            this.scheduleForm.get(this.TIME_TO).markAsPristine();
        } else if (hours != null && (minutes == null || minutes == "")) {
            this.minuteDurationForm = 0;
            this.scheduleForm.get(this.TIME_TO).setValue(hourFinish.format('HH:mm'));
            this.scheduleForm.get(this.TIME_TO).markAsPristine();
        }
        this.validateIfNextDay();
        this.setMinutesToLimit();
    }

    calcHours(hourDurationForm: number, minuteDurationForm: number): number {
        return parseFloat((minuteDurationForm / 60).toFixed(2)) + hourDurationForm
    }

    validateIfNextDay() {
        if (this.timeToForm !== '00:00') {
            this.isNextDay = moment(this.timeToForm, 'HH:mm').diff(moment(this.timeFromForm, 'HH:mm')) <= 0;
        } else {
            this.isNextDay = false
        }
    }

    // Limits is 24 HH and 00 mm
    setMinutesToLimit() {
        if (this.hourDurationForm >= 24) {
            this.minuteDurationForm = 0;
            this.scheduleForm.get(this.MINUTE_DURATION).disable();
        } else {
            this.scheduleForm.get(this.MINUTE_DURATION).enable();
        }
    }

    onSelectedAttentionRepeat(event) {
        this.repeatAttention = event;
        this.defaultValueRepeatAttention = this.repeatAttention
        this.repeatAttentionForm = event;

    }

    onSelectedStateAttention(event) {
        this.defaultValueStateAttention = event;
        this.stateAttentionForm = event;

    }

    repeatAttentions(attentions, N) {
        return attentions.flatMap(att => Array.from({ length: N }, () => att));
    }

    assignColorsToAgreements() {
        let agreements = Array.from(new Set(this.attentions?.flatMap(at => at.agreementId)))
        let colorIndex = this.colorsForAgreements.size != undefined ? this.colorsForAgreements.size : 0
        agreements?.forEach(agr => {
            if (!this.colorsForAgreements.has(agr)) {
                let color;
                if (colorIndex < colors.length) {
                    color = colors[colorIndex]
                    colorIndex++
                } else {
                    let randomColor = this.generalService.getRandomColor()
                    color = { primary: randomColor, secondary: randomColor }
                }
                this.colorsForAgreements.set(agr, color)
            }
        })
    }



    composeAttentionsToAgreements() {
        // Fuente única para no mezclar módulos/no-módulos en la grilla del dialog.
        // - Flujo normal: sólo atenciones NO-módulo (incluye el caso de derivación por provisionFeeId).
        // - Flujo módulos: sólo atenciones de agreements que pertenezcan a un módulo.
        // const sourceAttentions: Attention[] = !this.isModulesFlow
        //     ? (this.attentions ?? []).filter(at => this.isNonModuleAttention(at))
        //     : this.getAllCaseModuleAttentionsUnified().filter(at => this.isAgreementAttentionInsideCaseModule(at));
        if (!this.isModulesFlow) {
            this.agreements = this.agreements?.map(ag => {
                ag.attentions = this.filteredAttentions.filter(at =>
                    at.agreementId == ag.id
                    && (!this.provisionFeeSelected || at.provisionFeeId == this.provisionFeeSelected.id)
                    && (this.filterAttentions?.range?.contains(moment(at.fromDate)) ?? true)).sort((a, b) => moment(a.fromDate).isAfter(b.fromDate) ? 1 : -1);
                return ag
            })
        } else {
            let allCaseModulesAg = [];
            this.caseModules?.forEach(cm => {
                (cm?.provisions ?? []).forEach(pr => {
                    (pr?.agreements ?? []).forEach(ag => {
                        allCaseModulesAg.push(ag)
                    })
                })
            })
            this.agreements = allCaseModulesAg?.map(ag => {
                ag.attentions = this.filteredAttentions.filter(at =>
                    at.agreementId == ag.id
                    && (!this.provisionFeeSelected || at.provisionFeeId == this.provisionFeeSelected.id)
                    && (this.filterAttentions?.range?.contains(moment(at.fromDate)) ?? true)).sort((a, b) => moment(a.fromDate).isAfter(b.fromDate) ? 1 : -1);
                return ag
            })
        }
    }

    getAttentionDayText(att: Attention) {
        return moment(att.fromDate).format('ddd DD MMM');
    }

    getAttentionHourSpan(att: Attention) {
        return moment(att.fromDate).format('HH:mm') + ' - ' + moment(att.toDate).format('HH:mm')
    }

    get practiceCountedByHours() {
        if (!this.isModulesFlow) {
            return this.provisionFeeSelected.practice.restriction.requiredTime
        }
    }

    practiceModuleCountedByHours(pv: Provision) {
        return pv.practice.restriction.requiredTime
    }

    getCaseModuleName(id: number): string {
        const cm = this.caseModules?.find(m => Number(m?.id) === Number(id));
        return cm?.name ?? '';
    }

    getEventTitle(attention: Attention): string {
        // Módulos: usar nombre del módulo (inyectado por el padre)
        if (attention.type === AttentionType.MODULE) {
            const cmName = (attention as any)?.caseModuleName;
            if (typeof cmName === 'string' && cmName.trim().length) return cmName.trim();
            return attention?.practice?.name ?? 'Módulo';
        }
    };


    attentionsToEvents(attentions: Attention[]): CalendarEvent[] {
        // Avoid console logging here — this method is called frequently during UI updates
        let list: Attention[] = Array.isArray(attentions) ? attentions : [];
        // En flujo normal, este calendario corresponde a acuerdos/prestaciones: nunca mezclar atenciones de módulos.
        // if (!this.caseModulesFlow) {
        //     list = this.practiceAttentions;
        // }

        const events: CalendarEvent[] = list
            .filter(at => at.provisionFeeId == this.provisionFeeSelected?.id)
            .map(attention => {
                const start = new Date(attention.fromDate);
                const end = this.normalizeEventEnd(attention, start);

                const event: CalendarEvent = {
                    id: attention.id,
                    color: this.colorsForAgreements.get(attention.agreementId),
                    title: attention.type === AttentionType.MODULE ? this.getCaseModuleName(attention.caseModuleId) : `${this.entitiesFacade.getProvidersFullName(attention?.provider)} - $${attention?.providerFee}`,
                    start,
                    cssClass: 'color-white',
                    end: end,
                    draggable: false,
                    allDay: false,
                    resizable: { beforeStart: false, afterEnd: false },
                    meta: {
                        attention,
                        referenceText: `${attention?.practice?.name} • ${attention?.patient?.surname} | ${this.entitiesFacade.getProvidersFullName(attention?.provider)}`,
                    }
                };



                return event;
            });
        return events;
    }

    moduleAttentionsToEvents(attentions: Attention[]) {
        const pfMap = this.getProvisionFeeCaseModuleIdByProvisionFeeId();

        const events: CalendarEvent[] = (attentions ?? [])
            // .filter((at) => this.getCaseModuleIdForAttention(at, pfMap) === moduleId)
            .map(attention => {
                const start = new Date(attention.fromDate);
                const end = this.normalizeEventEnd(attention, start);
                const isModuleAttention = attention.type === AttentionType.MODULE;
                const color = (attention?.agreementId != null ? this.colorsForAgreements.get(attention.agreementId) : null)
                    ?? { primary: '#334151', secondary: '#334151' };
                const event: CalendarEvent = {
                    id: attention.id,
                    color,
                    title: isModuleAttention ? this.getCaseModuleName(attention.caseModuleId) : `${this.entitiesFacade.getProvidersFullName(attention?.provider)} - $${attention?.providerFee}`,
                    start,
                    cssClass: 'color-white',
                    end: end,
                    draggable: false,
                    allDay: false,
                    resizable: { beforeStart: false, afterEnd: false },
                    meta: {
                        attention,
                        kind: attention.type,
                        referenceText: `${attention?.practice?.name ?? 'Módulo'} • ${attention?.patient?.surname ?? ''} | ${this.entitiesFacade.getProvidersFullName(attention?.provider)}`,
                    }
                };
                return event;
            });

        // Filter by caseModuleId when a module is selected
        const selectedCmId = this.caseModuleSelected?.id ?? null;
        // Calendar (month/week/day) shows attentions filtered by selected caseModule
        // Derivar caseModuleId desde provisionFeeId cuando attention.caseModuleId es null
        let filteredEvents = (selectedCmId != null
            ? events.filter(ev => {
                const att = (ev as any)?.meta?.attention;
                const derivedCmId = att?.caseModuleId ?? pfMap.get(att?.provisionFeeId) ?? null;
                return derivedCmId === selectedCmId;
            })
            : events
        ).filter(ev => !(ev as any)?.meta?.attention?.isSupply);

        // Filtro adicional según el modo activo dentro del diálogo de agenda
        if (this.billingModuleAttentionSelected) {
            // Modo facturación de módulo: solo atenciones de tipo MODULE del módulo seleccionado
            filteredEvents = filteredEvents.filter(ev => {
                const att = (ev as any)?.meta?.attention;
                return att?.type === AttentionType.MODULE && att?.caseModuleId === selectedCmId;
            });
        } else if (this.caseModuleAgreementId != null && this.provisionFeeSelected) {
            // Modo acuerdo de práctica: mantener visibles todas las atenciones de la misma práctica,
            // aunque pertenezcan a otros acuerdos del mismo módulo.
            const activePfId = (this.provisionFeeSelected as any)?.id ?? null;
            filteredEvents = filteredEvents.filter(ev => {
                const att = (ev as any)?.meta?.attention;
                const matchPf = activePfId != null ? att?.provisionFeeId === activePfId : true;
                return matchPf;
            });
        }

        this.modulesMonthEvents = filteredEvents;
        // Left-side list "Module Attentions" should show ONLY billing-module attentions for the selected caseModule
        // AND filtered by the selected date range period
        const rangeFrom = this.dateRange?.historyFromDate ? moment(this.dateRange.historyFromDate).startOf('day') : null;
        const rangeTo = this.dateRange?.historyToDate ? moment(this.dateRange.historyToDate).endOf('day') : null;

        this.modulesBillingEvents = events.filter(ev => {
            const isModuleType = (ev as any)?.meta?.kind === AttentionType.MODULE;
            const matchesCaseModule = selectedCmId != null ? (ev as any)?.meta?.attention?.caseModuleId === selectedCmId : true;

            // Filter by date range if defined
            let withinDateRange = true;
            if (rangeFrom && rangeTo) {
                const attentionDate = moment(ev.start);
                withinDateRange = attentionDate.isBetween(rangeFrom, rangeTo, undefined, '[]');
            }

            return isModuleType && matchesCaseModule && withinDateRange;
        }).sort((a, b) => a.start.getTime() - b.start.getTime());
        this.refresh.next(null);
    }

    mapMonthEvents() {
        this.monthEvents = this.events.map((ev) => {
            // Use day-start timestamps to avoid heavy moment.isAfter calls
            // Original (commented for fallback):
            // ev.meta.isNotOneDayEvent = moment(ev.meta.attention.toDate).isAfter(ev.start, 'day');
            ev.meta.isNotOneDayEvent = this.dayStartTs(ev.meta.attention.toDate) > this.dayStartTs(ev.start);
            return ev
        })
    }

    onClickSeeMoreAttentions(_event: any, day: CalendarMonthViewDay) {
        _event.preventDefault();
        _event.stopPropagation();
        this.extraDayAttentions = day.events;
        let template = this.extraAttentionsTemplate;
        this.dayOpened = moment(day.date);

        const dialogWidth = 300;  // Ancho del diálogo
        const dialogHeight = 400; // Altura del diálogo

        // Calcula las posiciones deseadas basadas en el evento de clic
        let left = _event.clientX - dialogWidth / 2;
        let top = _event.clientY - dialogHeight;

        // Obtén los límites de la ventana del navegador
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;

        // Ajusta la posición si el diálogo se sale del lado izquierdo o derecho de la pantalla
        if (left < 0) {
            left = 0;
        } else if (left + dialogWidth > viewportWidth) {
            left = viewportWidth - dialogWidth;
        }

        // Ajusta la posición si el diálogo se sale de la parte superior o inferior de la pantalla
        if (top < 0) {
            top = 0;
        } else if (top + dialogHeight > viewportHeight) {
            top = viewportHeight - dialogHeight;
        }

        // Abre el diálogo con la posición ajustada
        this._dialogRefAttByDay = this.dialog.open(DialogComponent, {
            disableClose: false,
            minWidth: `${dialogWidth}px`,
            maxHeight: `${dialogHeight}px`,
            data: { template },
            position: { left: `${left}px`, top: `${top}px` }
        });
    }


    selectView(option) {
        this.view = option.value
        this.getRangeToFilterAttentions();
        this.setButtonsToCalendarNavigate(this.view);
        // this.viewDate = this.buttonsNewDateScheduleNavigator.dateToSetCalendar
        this.updateScheduleView();
    }

    applyDateSelectionPolicy(body: any) {
        body?.forEach(day => {
            if (!!this.dateRange) {
                if (moment(day.date).isValid()
                    && !(moment(day.date).isBetween(this.dateRange.historyFromDate, this.dateRange.historyToDate, undefined, '[]'))) {
                    day.inMonth = false; // Day disabled if out of range
                }
            }
        });
    }

    clickonCalendarPreviousNextView() {
        this.getRangeToFilterAttentions();
        this.setButtonsToCalendarNavigate(this.view, this.filterAttentions.date);
        // this.viewDate = this.buttonsNewDateScheduleNavigator.dateToSetCalendar
        this.updateScheduleView();
        this.composeAttentionsToAgreements();
    }

    disableDay(date: Date): boolean {
        // Si no hay rango definido, no deshabilitamos ningún día
        if (!this.minDate || !this.maxDate) {
            return false;
        }

        const mDate = moment(date);
        const mMin = moment(this.minDate);
        const mMax = moment(this.maxDate);

        // Deshabilitar si está fuera del rango [minDate, maxDate] inclusive
        const isBeforeMin = mDate.isBefore(mMin, 'day');
        const isAfterMax = mDate.isAfter(mMax, 'day');

        return isBeforeMin || isAfterMax;
    }

    deleteAttentionsBatch(agreement: Agreement) {

        this.provisionAgreements.push(agreement); // One agreement selected

        this._dialogRefWizardDelete = this.dialog.open(DialogComponent, {
            disableClose: true,
            minWidth: '30%',
            maxHeight: '90vh',
            data: { template: this.deleteWizardAttentions, title: 'Eliminar' }
        });
    }

    clickCancelDeleteWizard() {
        this._dialogRefWizardDelete.close();
    }

    deleteAttentionFromAgreementsGrid(attention: Attention) {
        this.isDeleteModeAttentionFromGridAgreements = true;
        this.onClickDeleteAttention(attention);
    }

    editAttentionFromAgreementsGrid(attention: Attention) {
        this.onEventClickedHandler({ calendarEvent: attention, editMode: 'UPD' });
    }

    editCaseModuleAttention(attention: Attention, ag: Agreement, provision: Provision, pf: ProvisionFee) {
        let agreementSelected = ag;
        this.editingCaseModuleAttention = true;
        let provisionSelected = provision;
        let provisionFeeSelected = { ...pf, practice: provisionSelected.practice };
        agreementSelected.provision = provisionSelected;
        agreementSelected.provisionFeeId = pf?.id ?? provision.provisionFeeId;
        agreementSelected.practice = provisionSelected.practice;
        this.agreementSelected = agreementSelected;
        this.provisionSelected = provisionSelected;
        this.caseModuleAgreementId = ag.id;
        this.agreementSelected = agreementSelected;
        this.provisionFeeSelected = provisionFeeSelected;
        this.onSelectedAgreement(ag.id);

        // Asegurar que provisionFeeId sobreviva si onSelectedAgreement reemplazó agreementSelected
        if (this.agreementSelected && this.agreementSelected.provisionFeeId == null) {
            this.agreementSelected.provisionFeeId = pf?.id ?? provision.provisionFeeId;
        }
        this.onEventClickedHandler({ calendarEvent: attention, editMode: 'UPD' });
    }

    findAndComposeModuleAttentions(id: number): AttentionEdit {
        let att = this.allModulesAttentions.find(att => att.id == id);
        let attentionEdit: AttentionEdit = {
            practiceDescription: 'Atención de módulo',
            id: att.id,
            fromDate: att.fromDate,
            toDate: att.toDate,
            practiceId: att.practiceId,
            agreementId: att.agreementId,
            hasEvolutions: false,
            state: {
                id: att.state.id,
                name: att.state.name,
            },
            agreements: [
            ],
            provisionFeeSelected: {
                id: null,
                fromDate: att.fromDate,
                toDate: att.toDate,
                practice: {
                    id: 0,
                    name: '',
                    restriction: {
                        id: 1,
                        name: '',
                        requiredTime: false,
                        requiredToDate: false
                    }
                },
                agreement: {
                    id: 0,
                    provider: {
                        id: 0,
                        name: '',
                        surname: ''
                    },
                    providerFee: 0,
                    fromDate: att.fromDate,
                    toDate: att.toDate
                },
                userId: 0,
                fee: 0,
                provider: {
                    id: 0,
                    name: '',
                    surname: ''
                },
                // Propiedades faltantes requeridas por ProvisionFee
                financierId: 0,
                profitMargin: 0,
                frequency: {
                    amount: null,
                    unit: null,
                    allowedHours: null
                }
            }
        };
        return attentionEdit;
    }

    editBillingModuleAttention(event) {
        const attention: Attention | undefined = (event?.meta?.attention ?? event) as Attention;

        // Si es una atención de módulo "facturable" (root), se edita con el builder especial.
        const isBillingModule = attention?.caseModuleId != null && attention?.agreementId == null;
        if (isBillingModule) {
            const composed = this.findAndComposeModuleAttentions(event?.id ?? attention?.id);
            this.attentionToEdit = {
                ...composed,
                practiceDescription: '',
                agreements: [],
                provisionFeeSelected: null
            };
            const title = 'Editar atención de módulo';
            this._dialogRefEditAttention = this.dialog.open(DialogComponent, {
                data: { template: this.editAttentionDialogTemplate, title, templateClass: 'margin: 0' },
            });
            return;
        }

        // Si es una atención de caseModule (vía agreements/provisionFees), reutilizamos el flujo normal de edición.
        this.onEventClickedHandler({ calendarEvent: attention, editMode: 'UPD' });
    }

    closeDialogAttentionEdit() {
        this._dialogRefEditAttention.close();
    }

    /**
     *
     * @returns Max date (in the future) for provisionFee's attentions
     */
    selectLastDate(): Date {
        const lastDate = this.attentions.filter(att => att.provisionFeeId == this.attentionToEdit.provisionFeeId).reduce((maxDate: Date, att: Attention) => {
            const attentionMoment = moment(att.fromDate);
            const maxFechaMoment = moment(maxDate);

            return attentionMoment.isAfter(maxFechaMoment) ? att.fromDate : maxDate;
        }, new Date(0));
        return lastDate;
    }

    // Click on attention for edit
    eventClicked(_event, event?: CalendarEvent) {
        if (event != null) {
            this.onEventClickedHandler({ calendarEvent: event.meta.attention, editMode: 'DSP' });
        } else {
            this.onEventClickedHandler({ calendarEvent: _event.meta.attention, editMode: 'DSP' });
        }
    }

    eventClickedX(event) {
        // kept for backwards compatibility; intentionally no-op
    }

    eventTimesChanged({ event, newStart, newEnd }: CalendarEventTimesChangedEvent): void {
        this.events = this.events.map((iEvent) => {
            if (iEvent === event) {
                return {
                    ...event,
                    start: newStart,
                    end: newEnd,
                };
            }
            return iEvent;
        });
        this.handleEvent('Dropped or resized', event);
    }

    handleEvent(action: string, event: CalendarEvent): void {
        if (action === 'Edit') {
            //   this.onEventClicked.emit(event.meta.attention);
            // no-op
        } else if (action === 'Deleted') {
            // this.onEventDelete.emit(event.meta.attention);
            // no-op
        }
    }

    overlapAdviceText(attention: Attention) {
        let overlapedAttention: AttentionOverlap;
        overlapedAttention = this.attentionsWithOverlap.find(att => att.id == attention.id && att.hasOverlap ? att : null)
        const text = this.attentionsService.overlapText(overlapedAttention);
        return text;
    }

    updateScheduleView() {
        this.viewDateX = this.viewDate;

        const actualMonth = moment(this.viewDate).month() + 1;
        const previousMonth = moment(this.previousViewDate).month() + 1;

        if (actualMonth != previousMonth) {
            this.previousViewDate = this.viewDate;
        }
    }

    getRangeToFilterAttentions() {

        switch (this.view) {
            case CalendarView.Month:
                this.filterAttentions = {
                    date: moment(this.viewDate).startOf('M').toDate(),
                    range: new momentRange.DateRange(moment(this.viewDate), moment(moment(this.viewDate).endOf('M').toDate()))
                }
                break;
            case CalendarView.Week:
                this.filterAttentions = {
                    date: this.viewDate,
                    range: new momentRange.DateRange(moment(this.viewDate), moment(moment(this.viewDate).endOf('W').toDate()))
                }
                break;

            case CalendarView.Day:
                this.filterAttentions = {
                    date: this.viewDate,
                    range: new momentRange.DateRange(moment(this.viewDate), moment(this.viewDate).endOf('D').toDate())
                }
                break;
            default:
                break;
        }
    }

    copyAttentionTo(attention: Attention) {
        if (!!this.datesToPostSelected && this.datesToPostSelected.length > 0) {
            const start = moment(attention.fromDate);
            const end = moment(attention.toDate);

            const dur = moment.duration(Math.abs(end.diff(start)));

            // Totales
            const totalMinutes = Math.floor(dur.asMinutes()); // 1440 en el mismo ejemplo

            // Si además querés horas:minutos “humanos”
            const hours = Math.floor(totalMinutes / 60);
            const minutes = totalMinutes % 60;
            this.onCreateAttentionV2(true, 'CPY', attention.fromDate, hours, minutes, attention.state.id)
        }
    }

    setButtonsToCalendarNavigate(view: CalendarView, date?: Date) {
        // Buttons are set with intersection between practice and first/last attention day loaded
        const rangeAtt = new momentRange.DateRange(this.rangeToNavigate?.historyFromDate, moment(moment(this.rangeToNavigate.historyToDate).format('YYYY-MM-DD')).toDate());

        const rangePractice = !!this.provisionFeeSelected ? new momentRange.DateRange(this.provisionFeeSelected?.fromDate, this.provisionFeeSelected?.toDate) :
            !!this.caseModuleSelected ? new momentRange.DateRange(moment(this.caseModuleSelected?.fromDate).toDate(), moment(this.caseModuleSelected?.toDate).startOf('day').toDate()) : null; // Workaround hours

        const intersect = rangePractice.intersect(rangeAtt);

        this.buttonsNewDateScheduleNavigator = this.generalService.controlCalendarView(intersect.start.toDate(), intersect.end.toDate(), view, date); // Navigate by attentions prev/next
        this.viewDate = this.buttonsNewDateScheduleNavigator.dateToSetCalendar;
        this.updateScheduleView();
        this.getRangeToFilterAttentions();
    }

    // Set to Agendar calendar
    setViewSelectedCalendarCase(event) {
        this.viewSelectedCalendarCase = event
    }

    replaceAgreementAttentionFromAgreementsGrid(attention: Attention) {
        this.onEventClickedHandler({ calendarEvent: attention, editMode: 'RPA' });
    }

    attachPatientToAttentions(): void {
        const byCase = this.patientByCaseId;
        this.attentions = (this.attentions ?? []).map(at =>
            at?.patient ? at : ({ ...at, patient: byCase.get(at.caseId) })
        );
    }

    toggleProvisionExpanded(index: number): void {
        this.provisionsExpanded.toggle(index);
    }

    isProvisionExpanded(index: number): boolean {
        return this.provisionsExpanded.selected.includes(index);
    }

    getAllCaseModuleAttentionsUnified(): Attention[] {
        const input = Array.isArray(this.attentions) ? this.attentions : [];
        const store = Array.isArray(this.allModulesAttentions) ? this.allModulesAttentions : [];
        const inputAll = input;
        const storeAll = store;

        // Dedupe by id, but MERGE when present in both.
        // Precedence: input wins (useful when the parent enriches attentions with extra fields).
        const byId = new Map<number, Attention>();
        const withoutId: Attention[] = [];

        for (const att of storeAll) {
            if (att?.id != null) byId.set(att.id, att);
            else withoutId.push(att);
        }

        for (const att of inputAll) {
            if (att?.id == null) {
                withoutId.push(att);
                continue;
            }
            const existing = byId.get(att.id);
            byId.set(att.id, existing ? ({ ...existing, ...att }) : att);
        }

        const result = [...byId.values(), ...withoutId];
        const byCase = this.patientByCaseId;
        return result.map(at => (at?.patient ? at : ({ ...at, patient: byCase.get(at.caseId) })));
    }

    private getProvisionFeeCaseModuleIdByProvisionFeeId(): Map<number, number> {
        const map = new Map<number, number>();

        // Fuente 1 (principal): estructura caseModulesComposed (lo que pinta la vista)
        for (const cm of (this.caseModules ?? [])) {
            const cmId = cm?.id;
            if (cmId == null) continue;
            for (const prov of (cm?.provisions ?? [])) {
                for (const pf of (prov?.provisionFees ?? [])) {
                    const pfId = (pf as any)?.id;
                    const pfCaseModuleId = (pf as any)?.caseModuleId;
                    if (pfId != null) map.set(Number(pfId), Number(pfCaseModuleId ?? cmId));
                }
            }
        }

        // Fuente 2 (fallback): caseModuleProvisionFeesWithPractices
        for (const pf of (this.caseModuleProvisionFeesWithPractices ?? [])) {
            const pfId = (pf as any)?.id;
            const pfCaseModuleId = (pf as any)?.caseModuleId;
            if (pfId != null && pfCaseModuleId != null && !map.has(Number(pfId))) {
                map.set(Number(pfId), Number(pfCaseModuleId));
            }
        }

        return map;
    }

    // Para una atención dada, obtener su caseModuleId (si tiene) ya sea directo o derivado por provisionFeeId.
    private getCaseModuleIdForAttention(att: Attention | null | undefined, pfCaseModuleIdByPfId?: Map<number, number>): number | null {
        if (!att) return null;
        if (att.caseModuleId != null) return Number(att.caseModuleId);

        const pfId = (att as any)?.provisionFeeId;
        if (pfId == null) return null;

        const map = pfCaseModuleIdByPfId ?? this.getProvisionFeeCaseModuleIdByProvisionFeeId();
        const derived = map.get(Number(pfId));
        return derived != null ? Number(derived) : null;
    }

    private filterUnifiedAttentionsAfterModuleComposition(attentions: Attention[]): Attention[] {
        let moduleAttentions = attentions.filter(at => at.type !== AttentionType.PRACTICE);
        return moduleAttentions;
        // const list = Array.isArray(attentions) ? attentions : []; // Unify caseModule-attentions from parent input and store, but filter by selected caseModuleIds (if any)
        // const ids = Array.isArray(this.provisionAgreementsInput?.caseModuleIds) ? this.provisionAgreementsInput?.caseModuleIds : []; // Selected caseModuleIds (if any) to filter by. Empty means "no filter" (show all).
        // const set = ids.length ? new Set(ids.map(Number)) : null; // Convert to Set for O(1) lookups, or null if no filter

        // const pfMap = this.getProvisionFeeCaseModuleIdByProvisionFeeId(); // Cache to avoid repeated map constructions during filtering
        // list.filter((att) => {
        //     const isModuleOrder = att.type === AttentionType.PRACTICE_MODULE && att.notManageable === true;
        //     const moduleId = this.getCaseModuleIdForAttention(att, pfMap);
        //     if (isModuleOrder) return true;
        //     if (moduleId == null) return false;
        //     if (!set) return true;
        //     return set.has(Number(moduleId));
        // });
        // return list;
    }


    onAttentionEditRefresh(): void {
        // 1) Mantener el comportamiento actual (avisar al padre)
        this.refreshDataFiltered.emit();

        // 2) En flujo módulos, forzar reload y rebuild para que la vista se actualice al volver
        if (this.isModulesFlow) {
            // Permitir re-fetch (si no, ensureModuleAttentionsLoaded() no hace nada)
            this.requestedModuleAttentionsForRange = false;

            this.ensureModuleAttentionsLoaded();

            // Reconstruir listas/eventos con lo último disponible (aunque el fetch llegue luego,
            // el subscribe a modulesFacade.getModulesAttentions$ vuelve a llamar maybeRebuildModuleView()).
            this.rebuildModuleCalendarAndList();
            return;
        }

        // 3) Flujo normal
        this.loadAttentionsByCase();
    }

    copyBillingModuleAttention(event: any): void {

        const attention = event

        // “Guardia”: mismas reglas que venís usando para inputs de hora (requiredTime)
        const isGuard = !!attention?.practice?.restriction?.requiredTime;
        if (!isGuard) return;

        // Reutiliza el comportamiento existente del flujo tradicional (copia exacta)
        this.copyAttentionTo(attention);

        // Refrescar vista (módulos) para que aparezca la copia al volver
        if (this.isModulesFlow) {
            this.requestedModuleAttentionsForRange = false;
            this.ensureModuleAttentionsLoaded();
            this.rebuildModuleCalendarAndList();
        }
    }

    private calcQuantityFromDatesIfNeeded(attention: Attention, fromDate: Date, toDate: Date | null, stateId: number): number | null {
        if (!toDate) return null;
        if (![this.ATTENTION_STATES.REALIZADA, this.ATTENTION_STATES.FACTURABLE].includes(Number(stateId))) return null;
        const requiredTime = !!attention?.practice?.restriction?.requiredTime;
        if (!requiredTime) return null;

        const start = moment(fromDate);
        const end = moment(toDate);
        if (!start.isValid() || !end.isValid()) return null;

        const totalMinutes = Math.max(0, Math.floor(moment.duration(end.diff(start)).asMinutes()));
        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;
        return this.calcHours(hours, minutes);
    }

    private coerceNonEpochDate(value: any): Date | null {
        if (value == null) return null;
        const d = new Date(value);
        if (isNaN(d.getTime())) return null;
        // Treat epoch as null (prevents creating 1969 end dates)
        if (d.getTime() === 0) return null;
        return d;
    }

    copyCaseModuleAgreementAttention(attention: Attention): void {
        // Only for "case module" attentions that belong to an agreement (not billing-module root attentions)
        const agreementId = attention?.agreementId ?? null;
        const provisionFeeId = (attention as any)?.provisionFeeId ?? null;
        if (!agreementId || !provisionFeeId || !this.case?.id) return;

        const fromDate = this.coerceNonEpochDate((attention as any)?.fromDate) ?? new Date();
        const toDate = this.coerceNonEpochDate((attention as any)?.toDate);
        const stateId = Number(attention?.state?.id ?? this.ATTENTION_STATES.AGENDADA);

        const payload: any = {
            agreementId,
            provisionFeeId,
            stateId,
            fromDate,
            toDate: toDate ?? null,
            caseId: this.case.id,
            expand: ['provider', 'practice', 'patient'],
        };

        // Preserve quantity if present, otherwise compute for hours-counted practices
        const existingQty = (attention as any)?.quantity;
        payload.quantity = existingQty != null ? existingQty : this.calcQuantityFromDatesIfNeeded(attention, fromDate, toDate ?? null, stateId);

        this.loadingCreateAttention = true;

        this.postAttentionV2([payload])
            .then((res: any) => {
                // Ensure local list updates even if parent input arrives later
                const created = (this.attentionsService.checkToDate(res) || []) as Attention[];
                if (created.length) {
                    const current = Array.isArray(this.attentions) ? this.attentions : [];
                    this.attentions = [...current, ...created];
                }

                // Rebuild module view so it appears immediately
                if (this.isModulesFlow) {
                    this.rebuildModuleCalendarAndList();
                }

                Swal.fire({
                    text: 'Atención copiada correctamente',
                    icon: 'success',
                    timer: 2000,
                    showConfirmButton: false
                });
            })
            .catch(() => {
                // Errors are handled by the service; keep UX consistent
            })
            .finally(() => {
                this.loadingCreateAttention = false;
            });
    }

    getCaseModuleAttentionsForAgreementAndPf(agreement: Agreement, pf: any): Attention[] {
        const agreementId = agreement?.id ?? null;
        const provisionFeeId = pf?.id ?? null;

        if (!agreementId || !provisionFeeId) return [];

        const range = this.filterAttentions?.range;

        // Filtrar atenciones que pertenecen a este agreement, provisionFee y caseModule
        // En flujo módulos, las atenciones PRACTICE_MODULE tienen agreementId, provisionFeeId Y caseModuleId
        return (this.attentions ?? [])
            .filter(at =>
                at?.agreementId === agreementId &&
                at?.provisionFeeId === provisionFeeId &&
                (range ? range.contains(moment(at.fromDate)) : true)
            )
            .sort((a, b) => (moment(a.fromDate).isAfter(b.fromDate) ? 1 : -1));
    }

    setBillingModuleModeFormValidators(): void {
        if (!this.scheduleForm) return;

        const agCtrl = this.scheduleForm.get(this.AGREEMENT);
        const pfCtrl = this.scheduleForm.get(this.PROVISION_FEE);

        // En "facturable de módulo" no hay agreement
        agCtrl?.clearValidators();
        agCtrl?.reset(); // agreement sí se limpia
        agCtrl?.updateValueAndValidity({ emitEvent: false });

        // PROVISION_FEE en flujo módulos = selector de módulo => NO resetear el valor
        pfCtrl?.clearValidators();
        pfCtrl?.updateValueAndValidity({ emitEvent: false });
    }

    setAgreementModeFormValidators(): void {
        if (!this.scheduleForm) return;

        // Volver al comportamiento normal: ambos requeridos
        const agCtrl = this.scheduleForm.get(this.AGREEMENT);
        const pfCtrl = this.scheduleForm.get(this.PROVISION_FEE);

        agCtrl?.setValidators([CustomValidators.required('Acuerdo prestacional requerido')]);
        pfCtrl?.setValidators([CustomValidators.required('Prestación requerida')]);

        agCtrl?.updateValueAndValidity({ emitEvent: false });
        pfCtrl?.updateValueAndValidity({ emitEvent: false });
    }

}
